export const arTranslations = {
  // ===========================================
  // SEO Meta Tags - Arabic First
  // ===========================================
  
  // Site-wide SEO
  'seo.siteName': 'هُدًى للمتقين - منصة تعليم القرآن والعربية',
  
  // Homepage SEO
  'seo.home.title': 'تعلم القرآن أونلاين — تجويد وتحفيظ وعربية | هُدًى للمتقين',
  'seo.home.description': 'دروس قرآن مباشرة فردية مع معلمين ومعلمات مجازين بالسند. تجويد وتحفيظ وقاعدة نورانية للأطفال والكبار — احجز حصة تجريبية مجانية اليوم.',
  'seo.home.keywords': 'تعلم القرآن أونلاين، دروس تجويد، حفظ القرآن، تعلم العربية، معلم قرآن، دروس قرآن للأطفال، تلاوة القرآن، دروس إسلامية، تعليم القرآن عن بعد، منصة تعليم إسلامي',
  
  // About Page SEO
  'seo.about.title': 'عن هُدًى للمتقين | رسالتنا في تعليم القرآن الكريم واللغة العربية',
  'seo.about.description': 'تعرف على منصة هُدًى للمتقين - منصة تعليمية رائدة تربط الطلاب بمعلمي القرآن واللغة العربية المؤهلين من جميع أنحاء العالم. رؤيتنا ورسالتنا وقيمنا.',
  'seo.about.keywords': 'عن منصة هُدًى، تعليم القرآن، معلمون مؤهلون، رؤية تعليمية، تعليم إسلامي عبر الإنترنت، منصة قرآنية، تعلم العربية الفصحى',
  
  // Courses Page SEO
  'seo.courses.title': 'دورات قرآن أونلاين — تجويد وتحفيظ وعربية | هُدًى',
  'seo.courses.description': 'أكثر من 50 دورة: تجويد للمبتدئين، برامج تحفيظ، قاعدة نورانية للأطفال، تفسير وعربية قرآنية. دروس مباشرة مع معلمين خبراء وحصة تجريبية مجانية.',
  'seo.courses.keywords': 'دورات تجويد، دورات حفظ القرآن، تفسير القرآن، تعلم العربية القرآنية، دروس للأطفال، دورات إسلامية أونلاين، تعلم التلاوة، القراءات العشر',
  
  // Teachers Page SEO
  'seo.teachers.title': 'معلمو ومعلمات القرآن — مجازون بالسند | هُدًى',
  'seo.teachers.description': 'تصفح أكثر من 30 معلمًا ومعلمة قرآن مجازين في التجويد والتحفيظ والعربية. قارن الأسعار والتقييمات واحجز حصة تجريبية مجانية.',
  'seo.teachers.keywords': 'معلم قرآن، أستاذ تجويد، معلمة حفظ، مدرس عربية، إجازة قرآنية، معلم أونلاين، شيخ قراءات، معلمة للأطفال',
  
  // Student Portal SEO
  'seo.studentPortal.title': 'بوابة الطالب | لوحة التحكم والدروس - هُدًى للمتقين',
  'seo.studentPortal.description': 'ادخل إلى بوابة الطالب لمتابعة دروسك، جدول حصصك، تقدمك في الحفظ والتجويد، والتواصل مع معلميك.',
  'seo.studentPortal.keywords': 'بوابة طالب، لوحة تحكم، متابعة الدروس، جدول الحصص، تقدم التعلم',
  
  // Teacher Portal SEO  
  'seo.teacherPortal.title': 'بوابة المعلم | إدارة الطلاب والدروس - هُدًى للمتقين',
  'seo.teacherPortal.description': 'بوابة المعلم لإدارة طلابك، جدول دروسك، وتتبع تقدم طلابك في تعلم القرآن واللغة العربية.',
  'seo.teacherPortal.keywords': 'بوابة معلم، إدارة طلاب، جدول دروس، تتبع تقدم، تدريس أونلاين',
  
  // Login Page SEO
  'seo.login.title': 'تسجيل الدخول | هُدًى للمتقين - منصة تعليم القرآن والعربية',
  'seo.login.description': 'سجل دخولك إلى حسابك في منصة هُدًى للمتقين للوصول إلى دروسك ومتابعة رحلتك في تعلم القرآن الكريم واللغة العربية.',
  'seo.login.keywords': 'تسجيل دخول، حساب طالب، حساب معلم، منصة تعليمية',
  
  // Register Page SEO
  'seo.register.title': 'إنشاء حساب | هُدًى لِلمُتَّقِين',
  'seo.register.description': 'أنشئ حسابك المجاني على منصة هُدًى — ابدأ تعلم القرآن مع معلمين معتمدين اليوم.',
  'seo.register.keywords': 'تسجيل حساب، إنشاء حساب، طالب جديد، معلم جديد، انضمام للمنصة',
  'seo.register.student.title': 'إنشاء حساب طالب | هُدًى',
  'seo.register.student.description': 'انضم إلى هُدًى كطالب — احجز جلسات مع معلمي القرآن المعتمدين في منطقتك الزمنية.',
  'seo.register.teacher.title': 'كن معلم قرآن | هُدًى',
  'seo.register.teacher.description': 'علّم القرآن عبر الإنترنت مع هُدًى — شارك إجازتك وحدد أسعارك وصل إلى طلاب حول العالم.',
  'seo.register.parent.title': 'إنشاء حساب ولي أمر | هُدًى',
  'seo.register.parent.description': 'افتح حساب عائلة على هُدًى — سجّل أبناءك واختر معلم القرآن المناسب لهم وتابع تقدمهم.',

  // Terms Page SEO (noindex)
  'seo.terms.title': 'شروط الخدمة | هُدًى',
  'seo.terms.description': 'اقرأ شروط الخدمة لمنصة هُدًى لِلمُتَّقِين — حقوقك ومسؤولياتك والتزاماتنا عند استخدام منصتنا لتعلم القرآن.',

  // Privacy Page SEO (noindex)
  'seo.privacy.title': 'سياسة الخصوصية | هُدًى',
  'seo.privacy.description': 'كيف تجمع منصة هُدًى لِلمُتَّقِين بياناتك الشخصية وتستخدمها وتحميها. متوافقة مع GDPR وشفافة.',

  // Blog Index SEO
  'seo.blog.title': 'مدونة هُدًى — تعلم القرآن والتجويد والعربية',
  'seo.blog.description': 'مقالات حول تعلم القرآن عبر الإنترنت والتجويد والحفظ واللغة العربية، كتبها معلمون معتمدون.',
  'seo.blog.keywords': 'مدونة قرآن، مقالات تجويد، نصائح حفظ، تعلم العربية، مدونة تعليم إسلامي',

  // ===========================================
  // Navigation
  // ===========================================
  'nav.home': 'الرئيسية',
  'nav.about': 'عن المنصة',
  'nav.courses': 'الدورات',
  'nav.teachers': 'المعلمون',
  'nav.login': 'تسجيل الدخول',
  'nav.register': 'التسجيل',

  // ===========================================
  // Hero Section
  // ===========================================
  'hero.title': 'تعلم القرآن مع معلمين خبراء',
  'hero.subtitle': 'هُدًى للمتقين يربط الطلاب المتفانين بمعلمي القرآن المؤهلين لتجارب تعليمية مخصصة.',
  'hero.findTeacher': 'ابحث عن معلم',
  'hero.becomeTeacher': 'كن معلمًا',
  'hero.personalizedLessons': 'دروس مخصصة',
  'hero.qualifiedTeachers': 'معلمون مؤهلون',
  'hero.flexibleSchedule': 'جدول مرن',

  // ===========================================
  // Teachers Section
  // ===========================================
  'teachers.featured': 'معلمونا المميزون',
  'teachers.featuredDesc': 'تعلم مع معلمينا ذوي التقييم العالي والخبراء في الدراسات القرآنية والمكرسين لمساعدة الطلاب على النجاح.',
  'teachers.viewAll': 'عرض جميع المعلمين',

  // ===========================================
  // Testimonials Section
  // ===========================================
  'testimonials.title': 'ماذا يقول طلابنا',
  'testimonials.subtitle': 'استمع إلى مجتمعنا حول تجاربهم في التعلم مع معلمينا المؤهلين.',

  // ===========================================
  // CTA Section
  // ===========================================
  'cta.title': 'هل أنت مستعد لبدء رحلتك القرآنية؟',
  'cta.subtitle': 'سواء كنت تبحث عن تعلم القرآن أو مشاركة معرفتك كمعلم، هُدًى للمتقين يوفر المنصة للتواصل والتميز.',
  'cta.forStudents': 'للطلاب',
  'cta.forTeachers': 'للمعلمين',
  
  // ===========================================
  // Footer
  // ===========================================
  'footer.description': 'منصة هُدًى للمتقين مكرسة لتوفير أعلى جودة في تعليم القرآن الكريم واللغة العربية للمتعلمين في جميع أنحاء العالم.',
  'footer.quickLinks': 'روابط سريعة',
  'footer.contactUs': 'اتصل بنا',
  'footer.rights': 'جميع الحقوق محفوظة.',
  'footer.privacyPolicy': 'سياسة الخصوصية',
  'footer.termsOfService': 'شروط الخدمة',
  'footer.faq': 'الأسئلة الشائعة',
  
  // ===========================================
  // Home Page Content
  // ===========================================
  'home.welcomeMessage': 'مرحبًا بك في منصة هُدًى للمتقين',
  'home.heroTitle': 'رحلتك نحو إتقان القرآن الكريم تبدأ هنا',
  'home.heroSubtitle': 'تعلم القرآن الكريم والتجويد والحفظ واللغة العربية مع نخبة من المعلمين المؤهلين من جميع أنحاء العالم الإسلامي',
  'home.learnWithBestTeachers': 'تعلم مع أفضل معلمي القرآن واللغة العربية من جميع أنحاء العالم',
  'home.startLearning': 'ابدأ رحلة التعلم',
  'home.exploreTeachers': 'تصفح المعلمين',
  'home.viewCourses': 'استعرض الدورات',
  
  // How It Works Section
  'home.howItWorks': 'كيف تعمل المنصة',
  'home.howItWorks.subtitle': 'أربع خطوات بسيطة لبدء رحلتك في تعلم القرآن الكريم واللغة العربية',
  'home.step1.title': 'أنشئ حسابك المجاني',
  'home.step1.desc': 'سجل في المنصة وأكمل ملفك الشخصي مع تحديد أهدافك التعليمية ومستواك الحالي',
  'home.step2.title': 'اختر معلمك المناسب',
  'home.step2.desc': 'تصفح ملفات المعلمين واختر الأنسب لك بناءً على تخصصه وجدوله وتقييمات الطلاب',
  'home.step3.title': 'احجز جلساتك',
  'home.step3.desc': 'اختر الأوقات المناسبة لك واحجز جلسات فردية أو جماعية حسب احتياجاتك',
  'home.step4.title': 'ابدأ التعلم',
  'home.step4.desc': 'تواصل مع معلمك عبر الفصل الافتراضي وابدأ رحلتك نحو إتقان القرآن',
  
  // Features Section
  'home.features.title': 'لماذا تختار هُدًى للمتقين؟',
  'home.features.subtitle': 'منصة متكاملة لتعليم القرآن الكريم واللغة العربية بأعلى المعايير',
  'home.feature1.title': 'معلمون مؤهلون',
  'home.feature1.desc': 'جميع معلمينا حاصلون على إجازات قرآنية وشهادات معتمدة في التعليم',
  'home.feature2.title': 'تعلم مرن',
  'home.feature2.desc': 'جدول دروس مرن يناسب وقتك أينما كنت في العالم',
  'home.feature3.title': 'دروس تفاعلية',
  'home.feature3.desc': 'فصول افتراضية حديثة مع أدوات تفاعلية للتلاوة والتصحيح',
  'home.feature4.title': 'متابعة مستمرة',
  'home.feature4.desc': 'تقارير تقدم منتظمة وتقييم مستمر لمستواك',
  
  // Testimonials
  'home.testimonials.title': 'ماذا يقول طلابنا',
  'home.testimonials.subtitle': 'قصص نجاح من طلابنا حول العالم',
  
  // CTA Section
  'home.cta.title': 'ابدأ رحلتك في تعلم القرآن اليوم',
  'home.cta.subtitle': 'انضم إلى آلاف الطلاب الذين يتعلمون القرآن الكريم واللغة العربية مع هُدًى للمتقين',
  'home.cta.registerStudent': 'سجل كطالب',
  'home.cta.registerTeacher': 'انضم كمعلم',
  
  // ===========================================
  // Teachers Page
  // ===========================================
  'teachers.title': 'معلمونا المؤهلون',
  'teachers.subtitle': 'اختر من بين نخبة من معلمي القرآن الكريم واللغة العربية المعتمدين',
  'teachers.search': 'ابحث عن معلم...',
  'teachers.subject': 'التخصص',
  'teachers.priceRange': 'نطاق السعر',
  'teachers.viewProfile': 'عرض الملف',
  'teachers.bookSession': 'احجز جلسة',
  'teachers.filters.tajweed': 'تجويد',
  'teachers.filters.hifz': 'حفظ',
  'teachers.filters.tafsir': 'تفسير',
  'teachers.filters.arabic': 'اللغة العربية',
  'teachers.filters.children': 'تعليم الأطفال',
  'teachers.studentsTaught': 'طالب تم تدريسهم',
  'teachers.experience': 'سنوات الخبرة',
  'teachers.availability': 'متاح',
  
  // ===========================================
  // Courses Page
  // ===========================================
  'courses.title': 'دوراتنا التعليمية',
  'courses.subtitle': 'اكتشف مجموعتنا الشاملة من دورات القرآن الكريم واللغة العربية',
  'courses.search': 'ابحث عن دورة...',
  'courses.category': 'التصنيف',
  'courses.level': 'المستوى',
  'courses.enrollNow': 'سجل الآن',
  'courses.learnMore': 'اعرف المزيد',
  'courses.duration': 'المدة',
  'courses.students': 'طالب مسجل',
  'courses.rating': 'التقييم',
  'courses.price': 'السعر',
  'courses.instructor': 'المعلم',
  'courses.categories.tajweed': 'التجويد',
  'courses.categories.hifz': 'الحفظ',
  'courses.categories.tafsir': 'التفسير',
  'courses.categories.arabic': 'اللغة العربية',
  'courses.categories.children': 'دورات الأطفال',
  'courses.levels.beginner': 'مبتدئ',
  'courses.levels.intermediate': 'متوسط',
  'courses.levels.advanced': 'متقدم',
  
  // ===========================================
  // About Page
  // ===========================================
  'about.title': 'عن هُدًى للمتقين',
  'about.heroTitle': 'رسالتنا: جعل تعليم القرآن متاحًا للجميع',
  'about.heroSubtitle': 'منصة هُدًى للمتقين تربط الطلاب بأفضل معلمي القرآن واللغة العربية لتجربة تعليمية فريدة',
  'about.story.title': 'قصتنا',
  'about.story.content': 'بدأت رحلتنا بهدف بسيط: تسهيل الوصول إلى تعليم القرآن الكريم عالي الجودة للمسلمين في كل مكان. اليوم، نفخر بخدمة آلاف الطلاب من جميع أنحاء العالم.',
  'about.mission.title': 'رسالتنا',
  'about.mission.content': 'توفير تعليم إسلامي عالي الجودة وسهل الوصول للمتعلمين في جميع أنحاء العالم، مع الحفاظ على الأصالة والتقاليد العلمية.',
  'about.vision.title': 'رؤيتنا',
  'about.vision.content': 'أن نصبح المنصة الرائدة عالميًا في تعليم القرآن الكريم واللغة العربية عبر الإنترنت.',
  'about.values.title': 'قيمنا',
  'about.values.excellence': 'التميز والإتقان',
  'about.values.authenticity': 'الأصالة والموثوقية',
  'about.values.accessibility': 'سهولة الوصول',
  'about.values.community': 'روح المجتمع',
  
  // ===========================================
  // Student Portal
  // ===========================================
  'studentPortal': 'بوابة الطالب',
  'studentDashboard': 'لوحة التحكم',
  'myCourses': 'دوراتي',
  'mySchedule': 'جدولي',
  'profile': 'الملف الشخصي',
  'dashboard': 'لوحة التحكم',
  'upcomingClasses': 'الدروس القادمة',
  'nextSevenDays': 'الأيام السبعة القادمة',
  'noUpcomingClasses': 'لا توجد دروس مجدولة',
  'enrolledCourses': 'الدورات المسجلة',
  'yourCourses': 'دوراتك',
  'noCoursesEnrolled': 'لم تسجل في أي دورات بعد',
  'progress': 'التقدم',
  'learningProgress': 'تقدمك في التعلم',
  'recommendedTeachers': 'المعلمون الموصى بهم',
  'basedOnInterests': 'بناءً على اهتماماتك',
  'noRecommendations': 'لا توجد توصيات بعد. أكمل ملفك الشخصي للحصول على توصيات مخصصة',
  'browseMoreCourses': 'تصفح المزيد من الدورات',
  'sampleCourseTitle': 'مقدمة في اللغة العربية',
  'sampleCourseTeacher': 'المعلم: أحمد الفارسي',
  'sampleCourseDescription': 'تعلم أساسيات اللغة العربية بما في ذلك الأبجدية والنطق والعبارات الشائعة.',
  'continueStudying': 'متابعة الدراسة',
  'calendar': 'التقويم',
  'selectDate': 'حدد تاريخًا لعرض الدروس المجدولة',
  'noDateSelected': 'لم يتم تحديد تاريخ',
  'scheduledClasses': 'الدروس المجدولة',
  'noClassesScheduled': 'لا توجد دروس مجدولة لهذا التاريخ',
  'startLearning': 'ابدأ التعلم',
  'browse.teachers': 'تصفح المعلمين',
  'browseTeachers': 'تصفح المعلمين',
  'bookNewSession': 'حجز جلسة جديدة',
  'mySessions': 'جلساتي',
  'bookSession': 'حجز جلسة',
  'selectConversation': 'اختر محادثة',
  'selectConversationDescription': 'اختر محادثة من القائمة لبدء المراسلة',
  'searchConversations': 'ابحث في المحادثات',
  'typeMessage': 'اكتب رسالة…',
  'loadingMessages': 'جارٍ تحميل الرسائل…',
  'noConversationsFound': 'لا توجد محادثات',
  'name': 'الاسم',
  'role': 'الدور',
  'status': 'الحالة',
  'manageTeachers': 'إدارة المعلمين',
  'manageStudents': 'إدارة الطلاب',
  'personalInformation': 'المعلومات الشخصية',
  'updateProfile': 'تحديث معلومات ملفك الشخصي',
  'firstName': 'الاسم الأول',
  'lastName': 'اسم العائلة',
  'email': 'البريد الإلكتروني',
  'emailChangeContact': 'لتغيير بريدك الإلكتروني، يرجى الاتصال بالدعم',
  'phone': 'رقم الهاتف',
  'learningInterests': 'اهتمامات التعلم',
  'profileUpdated': 'تم تحديث الملف الشخصي',
  'profileUpdateSuccess': 'تم تحديث ملفك الشخصي بنجاح',
  'saving': 'جارٍ الحفظ...',
  'saveChanges': 'حفظ التغييرات',
  
  // ===========================================
  // Appearance Settings
  // ===========================================
  'appearance': 'المظهر',
  'appearanceSettings': 'إعدادات المظهر',
  'colors': 'الألوان',
  'logoAndImages': 'الشعار والصور',
  'typography': 'الخطوط',
  'settingsSaved': 'تم حفظ الإعدادات',
  'appearanceUpdated': 'تم تحديث إعدادات المظهر بنجاح',
  'colorScheme': 'نظام الألوان',
  'colorSchemeDescription': 'تخصيص الألوان المستخدمة في جميع أنحاء التطبيق',
  'primaryColor': 'اللون الأساسي',
  'secondaryColor': 'اللون الثانوي',
  'accentColor': 'لون التمييز',
  'textColor': 'لون النص',
  'colorPreview': 'معاينة الألوان',
  'primary': 'أساسي',
  'secondary': 'ثانوي',
  'accent': 'تمييز',
  'text': 'نص',
  'logoDescription': 'قم بتحميل شعارك والأيقونة المفضلة',
  'mainLogo': 'الشعار الرئيسي',
  'logoPreview': 'معاينة الشعار',
  'logoRequirements': 'الحجم الموصى به: 200×60 بكسل. التنسيقات المدعومة: PNG، SVG مع خلفية شفافة.',
  'favicon': 'أيقونة المفضلة',
  'icon': 'أيقونة',
  'faviconRequirements': 'الحجم الموصى به: 32×32 بكسل. التنسيقات المدعومة: ICO، PNG.',
  'typographyDescription': 'تخصيص الخطوط المستخدمة في جميع أنحاء التطبيق',
  'englishFont': 'خط اللغة الإنجليزية',
  'arabicFont': 'خط اللغة العربية',
  'fontSampleEnglish': 'The quick brown fox jumps over the lazy dog.',
  'fontSampleArabic': 'هَذَا النَّصُّ هُوَ مِثَالٌ لِنَصٍّ يُمْكِنُ أَنْ يَسْتَبْدِلَ فِي نَفْس المَساحَة.',
  
  // ===========================================
  // Content Settings
  // ===========================================
  'content': 'المحتوى',
  'contentSettings': 'إعدادات المحتوى',
  'contentUpdated': 'تم تحديث إعدادات المحتوى بنجاح',
  'homepage': 'الصفحة الرئيسية',
  'aboutPage': 'صفحة عن المنصة',
  'aboutPageContent': 'محتوى صفحة عن المنصة',
  'aboutPageDescription': 'تحرير محتوى صفحة عن المنصة',
  'seoSettings': 'إعدادات تحسين محركات البحث',
  'homepageContent': 'محتوى الصفحة الرئيسية',
  'homepageDescription': 'تعديل المحتوى المعروض على الصفحة الرئيسية',
  'heroTitle': 'عنوان البانر الرئيسي',
  'defaultHeroTitle': 'مرحبًا بك في منصة هُدًى للمتقين',
  'heroSubtitle': 'العنوان الفرعي للبانر',
  'defaultHeroSubtitle': 'تعلم مع أفضل معلمي القرآن واللغة العربية من جميع أنحاء العالم',
  'heroImage': 'صورة البانر',
  'ctaButtonText': 'نص زر الدعوة للعمل',
  'defaultCtaText': 'ابدأ التعلم',
  'featuredSections': 'الأقسام المميزة',
  'section1Title': 'عنوان القسم 1',
  'defaultSection1Title': 'تعلم القرآن عبر الإنترنت',
  'section1Content': 'محتوى القسم 1',
  'defaultSection1Content': 'تواصل مع معلمي القرآن المؤهلين وتعلم التجويد والتلاوة والحفظ بالوتيرة الخاصة بك.',
  'section2Title': 'عنوان القسم 2',
  'defaultSection2Title': 'أتقن اللغة العربية',
  'section2Content': 'محتوى القسم 2',
  'defaultSection2Content': 'تعلم اللغة العربية الفصحى الحديثة والعربية الكلاسيكية ومهارات المحادثة مع معلمين خبراء.',
  'aboutTitle': 'عنوان عن المنصة',
  'defaultAboutTitle': 'عن منصة هُدًى للمتقين',
  'aboutContent': 'محتوى عن المنصة',
  'defaultAboutContent': 'منصة هُدًى للمتقين مكرسة لربط الطلاب بمعلمين مؤهلين لتعلم القرآن واللغة العربية. مهمتنا هي جعل التعليم الإسلامي الجيد متاحًا للجميع.',
  'aboutImage': 'صورة عن المنصة',
  'missionStatement': 'بيان المهمة',
  'defaultMissionStatement': 'توفير تعليم إسلامي عالي الجودة وسهل الوصول للمتعلمين في جميع أنحاء العالم.',
  'visionStatement': 'بيان الرؤية',
  'defaultVisionStatement': 'أن نصبح المنصة الرائدة في تعليم القرآن واللغة العربية عبر الإنترنت.',
  'seoDescription': 'تكوين إعدادات تحسين محركات البحث للحصول على رؤية أفضل في البحث',
  'siteTitle': 'عنوان الموقع',
  'metaDescription': 'وصف الميتا',
  'defaultMetaDescription': 'منصة هُدًى للمتقين تربط الطلاب بمعلمين مؤهلين للقرآن واللغة العربية للتعلم عبر الإنترنت المخصص.',
  'metaKeywords': 'كلمات الميتا الرئيسية',
  'separateKeywords': 'افصل بين الكلمات الرئيسية بفواصل',
  'ogImage': 'صورة وسائل التواصل الاجتماعي',
  'ogImageDescription': 'سيتم عرض هذه الصورة عند مشاركة موقعك على وسائل التواصل الاجتماعي. الحجم الموصى به: 1200×630 بكسل.',
  
  // ===========================================
  // Control Panel
  // ===========================================
  'controlPanel': 'لوحة التحكم',
  'backToDashboard': 'العودة إلى لوحة التحكم',
  
  // ===========================================
  // Payments
  // ===========================================
  'payments': 'المدفوعات',
  'paymentSettings': 'إعدادات الدفع',
  'paymentsUpdated': 'تم تحديث إعدادات الدفع بنجاح',
  'manualPayments': 'المدفوعات اليدوية',
  'manualPaymentsDescription': 'السماح للطلاب بالدفع عبر التحويل المصرفي أو الطرق الأخرى غير المتصلة بالإنترنت',
  'enableManualPayments': 'تمكين المدفوعات اليدوية',
  'enableManualPaymentsDescription': 'سيتمكن الطلاب من الدفع عبر التحويل المصرفي',
  'bankDetails': 'التفاصيل المصرفية',
  'bankDetailsPlaceholder': 'أدخل تفاصيل حسابك المصرفي للتحويلات اليدوية...',
  'paymentInstructions': 'تعليمات الدفع',
  'paymentInstructionsPlaceholder': 'أدخل تعليمات للطلاب حول كيفية إكمال الدفع...',
  'integration': 'دمج',
  'paypalDescription': 'قبول المدفوعات عبر باي بال',
  'enablePayPal': 'تمكين باي بال',
  'enablePayPalDescription': 'سيتمكن الطلاب من الدفع عبر باي بال',
  'paypalClientId': 'معرف عميل باي بال',
  'paypalClientSecret': 'السر المشترك لباي بال',
  'testMode': 'وضع الاختبار',
  'enableTestMode': 'تمكين وضع الاختبار',
  'testModeDescription': 'استخدام بيانات اعتماد الصندوق الرملي لاختبار المدفوعات',
  'stripeDescription': 'قبول المدفوعات عبر سترايب',
  'enableStripe': 'تمكين سترايب',
  'enableStripeDescription': 'سيتمكن الطلاب من الدفع عبر سترايب',
  'stripePublishableKey': 'مفتاح سترايب القابل للنشر',
  'stripeSecretKey': 'مفتاح سترايب السري',
  'stripeSecretKeyWarning': 'يجب الحفاظ على هذا المفتاح آمنًا. سيتم تخزينه مشفرًا.',
  'stripeWebhookSecret': 'سر ويب هوك سترايب',

  // ===========================================
  // Admin Dashboard
  // ===========================================
  'adminDashboard': 'لوحة تحكم المسؤول',
  'totalStudents': 'إجمالي الطلاب',
  'totalTeachers': 'إجمالي المعلمين',
  'coursesOffered': 'الدورات المقدمة',
  'monthlyRevenue': 'الإيرادات الشهرية',
  'recentActivity': 'النشاط الأخير',
  'last30Days': 'آخر 30 يومًا',
  'newStudentRegistered': 'تسجيل طالب جديد',
  'daysAgo': 'أيام مضت',
  'newCourseCreated': 'تم إنشاء دورة جديدة',
  'paymentReceived': 'تم استلام الدفعة',
  'performanceMetrics': 'مقاييس الأداء',
  'chartsComingSoon': 'الرسوم البيانية والتحليلات التفصيلية قادمة قريبًا!',
  
  // ===========================================
  // Teacher Portal
  // ===========================================
  'teacherDashboard': 'لوحة تحكم المعلم',
  'activeCourses': 'الدورات النشطة',
  'todaySchedule': 'جدول اليوم',
  'todayClasses': 'دروس اليوم',
  'noClassesToday': 'لا توجد دروس مجدولة لليوم',
  'recentMessages': 'الرسائل الأخيرة',
  'fromStudents': 'من الطلاب',
  'noMessages': 'لا توجد رسائل حتى الآن',
  'personalInfo': 'المعلومات الشخصية',
  'professionalInfo': 'المعلومات المهنية',
  'qualifications': 'المؤهلات',
  'location': 'الموقع',
  'professionalInformation': 'المعلومات المهنية',
  'teachingProfile': 'ملف التدريس',
  'biography': 'السيرة الذاتية',
  'sampleTeacherBio': 'أعمل في تدريس العربية القرآنية لأكثر من 5 سنوات، متخصص في التجويد والحفظ. تركز منهجية التدريس الخاصة بي على مسارات تعليمية مخصصة لكل طالب.',
  'teachingLanguages': 'لغات التدريس',
  'specialties': 'التخصصات',
  'yearsOfExperience': 'سنوات الخبرة',
  'hourlyRate': 'السعر بالساعة',
  'certificationsEducation': 'الشهادات والتعليم',
  'education': 'التعليم',
  'certifications': 'الشهادات',
  'teachingMethodology': 'منهجية التدريس',
  'sampleTeachingMethodology': 'ينهجي يجمع بين طرق تعليم القرآن التقليدية وتقنيات التعليم الحديثة، مع التركيز على النطق الصحيح والفهم والحفظ. أقوم بخلق بيئة داعمة للطلاب من جميع المستويات.',
  'uploadDocuments': 'تحميل المستندات',
  'uploadDocumentsDescription': 'قم بتحميل شهادات الدرجة العلمية، ومؤهلات التدريس، وغيرها من الوثائق ذات الصلة',
  'createCourse': 'إنشاء دورة',
  'studentsEnrolled': 'الطلاب المسجلين',
  'draftStatus': 'مسودة',
  'editCourse': 'تحرير الدورة',
  'addAvailability': 'إضافة التوفر',
  'setUpSchedule': 'إعداد الجدول',
  'myStudents': 'طلابي',
  'searchStudents': 'البحث عن الطلاب...',
  'studentsList': 'قائمة الطلاب',
  'viewManageStudents': 'عرض وإدارة طلابك',
  'noStudentsYet': 'لا يوجد طلاب مسجلين بعد',
  'inviteStudents': 'دعوة الطلاب',
  
  // ===========================================
  // Common / Misc
  // ===========================================
  'integrations': 'التكاملات',
  'users': 'المستخدمون',
  'notifications': 'الإشعارات',
  'messages': 'الرسائل',
  'schedule': 'الجدول',
  'teacherPortal': 'بوابة المعلم',
  'loading': 'جارٍ التحميل...',
  'error': 'حدث خطأ',
  'success': 'تم بنجاح',
  'cancel': 'إلغاء',
  'confirm': 'تأكيد',
  'delete': 'حذف',
  'edit': 'تعديل',
  'save': 'حفظ',
  'submit': 'إرسال',
  'back': 'رجوع',
  'next': 'التالي',
  'previous': 'السابق',
  'search': 'بحث',
  'filter': 'تصفية',
  'sort': 'ترتيب',
  'all': 'الكل',
  'none': 'لا شيء',
  'yes': 'نعم',
  'no': 'لا',

  // ===========================================
  // Marketing & Landing Page Content
  // ===========================================

  // Hero Section - Enhanced
  'hero.badge': 'منصة تعليمية موثوقة',
  'hero.mainTitle': 'رحلتك نحو إتقان القرآن الكريم تبدأ هنا',
  'hero.cta.primary': 'ابدأ رحلة التعلم مجاناً',
  'hero.cta.secondary': 'تصفح المعلمين',
  'hero.stats.students': 'طالب نشط',
  'hero.stats.teachers': 'معلم مؤهل',
  'hero.stats.countries': 'دولة حول العالم',
  'hero.stats.satisfaction': 'نسبة رضا الطلاب',

  // Trust Badges
  'trust.certified': 'معلمون حاصلون على إجازات قرآنية',
  'trust.secure': 'دفع آمن ومضمون',
  'trust.support': 'دعم فني على مدار الساعة',
  'trust.guarantee': 'ضمان استرداد الأموال خلال 7 أيام',

  // Features Section - Enhanced
  'features.sectionTitle': 'لماذا يختار الآلاف منصة هُدًى للمتقين؟',
  'features.sectionSubtitle': 'منصة متكاملة صُممت لتجعل تعلم القرآن واللغة العربية تجربة ممتعة وفعّالة',

  'features.qualified.title': 'معلمون مؤهلون ومُجازون',
  'features.qualified.desc': 'جميع معلمينا حاصلون على إجازات قرآنية موثقة وشهادات معتمدة في التعليم، مع خبرة لا تقل عن 3 سنوات',

  'features.flexible.title': 'تعلم في أي وقت ومن أي مكان',
  'features.flexible.desc': 'جدول دروس مرن يناسب وقتك وظروفك، مع إمكانية الوصول من أي جهاز وأي مكان في العالم',

  'features.interactive.title': 'دروس تفاعلية حديثة',
  'features.interactive.desc': 'فصول افتراضية مجهزة بأحدث الأدوات التفاعلية للتلاوة والتصحيح والمتابعة',

  'features.tracking.title': 'متابعة مستمرة لتقدمك',
  'features.tracking.desc': 'تقارير تقدم مفصلة وتقييم مستمر لمستواك مع خطة تعليمية مخصصة',

  'features.personalized.title': 'منهج مخصص لك',
  'features.personalized.desc': 'برنامج تعليمي يُصمم خصيصاً بناءً على مستواك وأهدافك وسرعة تعلمك',

  'features.affordable.title': 'أسعار مناسبة للجميع',
  'features.affordable.desc': 'باقات متنوعة تناسب جميع الميزانيات مع إمكانية الدفع بالتقسيط',

  // Courses Section - Enhanced
  'courses.sectionTitle': 'دوراتنا المتميزة',
  'courses.sectionSubtitle': 'برامج تعليمية شاملة صممها خبراء في تعليم القرآن واللغة العربية',

  'courses.tajweed.title': 'دورة التجويد الشاملة',
  'courses.tajweed.desc': 'تعلم أحكام التجويد من الصفر حتى الإتقان مع تطبيق عملي على آيات القرآن الكريم',
  'courses.tajweed.duration': '24 ساعة تدريبية',
  'courses.tajweed.level': 'جميع المستويات',

  'courses.hifz.title': 'برنامج حفظ القرآن',
  'courses.hifz.desc': 'برنامج متكامل لحفظ القرآن الكريم مع منهجية علمية للحفظ والمراجعة والتثبيت',
  'courses.hifz.duration': 'حسب خطة الحفظ',
  'courses.hifz.level': 'جميع المستويات',

  'courses.arabic.title': 'اللغة العربية القرآنية',
  'courses.arabic.desc': 'تعلم اللغة العربية من خلال القرآن الكريم - نحو، صرف، بلاغة، ومعاني الكلمات',
  'courses.arabic.duration': '36 ساعة تدريبية',
  'courses.arabic.level': 'متوسط ومتقدم',

  'courses.kids.title': 'القرآن للأطفال',
  'courses.kids.desc': 'برنامج تعليمي ممتع ومشوق للأطفال من سن 5 سنوات مع أساليب تفاعلية',
  'courses.kids.duration': 'جلسات 30 دقيقة',
  'courses.kids.level': 'للأطفال 5-12 سنة',

  // Testimonials - Enhanced
  'testimonials.sectionTitle': 'ماذا يقول طلابنا عنا',
  'testimonials.sectionSubtitle': 'آلاف الطلاب من حول العالم يشاركون تجربتهم مع منصة هُدًى للمتقين',

  'testimonials.1.text': 'بفضل الله ثم هذه المنصة، تمكن ابني من حفظ 5 أجزاء في أقل من سنة. المعلم ممتاز والمنهج رائع.',
  'testimonials.1.name': 'أم محمد',
  'testimonials.1.location': 'الولايات المتحدة',
  'testimonials.1.role': 'أم لطفلين',

  'testimonials.2.text': 'كنت أبحث عن معلمة قرآن للبنات منذ فترة. وجدت في هُدًى للمتقين معلمات مؤهلات ومحجبات. جزاهم الله خيراً.',
  'testimonials.2.name': 'فاطمة أحمد',
  'testimonials.2.location': 'بريطانيا',
  'testimonials.2.role': 'طالبة تجويد',

  'testimonials.3.text': 'أنا مسلم جديد وكنت لا أعرف كيف أقرأ القرآن. الآن بعد 6 أشهر أقرأ بطلاقة والحمد لله. المنصة سهلة جداً.',
  'testimonials.3.name': 'عبدالله جونسون',
  'testimonials.3.location': 'كندا',
  'testimonials.3.role': 'مسلم جديد',

  'testimonials.4.text': 'كمعلم قرآن، أجد في هذه المنصة كل ما أحتاجه. الإدارة ممتازة، والطلاب جادون، والدفع منتظم.',
  'testimonials.4.name': 'الشيخ أحمد الحسيني',
  'testimonials.4.location': 'مصر',
  'testimonials.4.role': 'معلم قرآن وتجويد',

  // CTA Section - Enhanced
  'cta.feature1': 'جلسة تجريبية مجانية',
  'cta.feature2': 'ضمان استرداد الأموال',
  'cta.feature3': 'دعم فني مستمر',
  'cta.button.student': 'سجل كطالب الآن',
  'cta.button.teacher': 'انضم كمعلم',

  // FAQ Section
  'faq.sectionTitle': 'الأسئلة الشائعة',
  'faq.sectionSubtitle': 'إجابات على أكثر الأسئلة التي يطرحها طلابنا',

  'faq.q1': 'كيف أبدأ التعلم في المنصة؟',
  'faq.a1': 'ببساطة، أنشئ حساباً مجانياً، ثم تصفح المعلمين واختر المناسب لك، واحجز جلستك الأولى. نقدم جلسة تجريبية مجانية لجميع الطلاب الجدد.',

  'faq.q2': 'ما مؤهلات المعلمين في المنصة؟',
  'faq.a2': 'جميع معلمينا حاصلون على إجازات في القرآن الكريم من شيوخ معتمدين، ولديهم خبرة لا تقل عن 3 سنوات في التدريس. نتحقق من جميع الشهادات قبل قبول أي معلم.',

  'faq.q3': 'هل تقدمون دروساً للأطفال؟',
  'faq.a3': 'نعم، لدينا برامج مخصصة للأطفال من سن 5 سنوات فما فوق، مع معلمين متخصصين في تعليم الأطفال بأساليب تفاعلية وممتعة تناسب أعمارهم.',

  'faq.q4': 'ما هي طرق الدفع المتاحة؟',
  'faq.a4': 'نقبل جميع البطاقات الائتمانية، PayPal، التحويل البنكي، وبعض طرق الدفع المحلية. جميع المعاملات مشفرة وآمنة.',

  'faq.q5': 'هل يمكنني تغيير المعلم؟',
  'faq.a5': 'بالتأكيد! يمكنك تغيير المعلم في أي وقت إذا لم تكن مرتاحاً. نريدك أن تجد المعلم المثالي لك.',

  'faq.q6': 'ما هي سياسة الإلغاء؟',
  'faq.a6': 'يمكنك إلغاء أو إعادة جدولة أي جلسة قبل 24 ساعة على الأقل دون أي رسوم. نقدم أيضاً ضمان استرداد الأموال خلال 7 أيام.',

  // Social Proof
  'social.studentsCount': '+10,000',
  'social.studentsLabel': 'طالب حول العالم',
  'social.teachersCount': '+200',
  'social.teachersLabel': 'معلم مؤهل',
  'social.countriesCount': '+50',
  'social.countriesLabel': 'دولة',
  'social.rating': '4.9/5',
  'social.ratingLabel': 'تقييم الطلاب',

  // Value Propositions
  'value.free.title': 'جلسة تجريبية مجانية',
  'value.free.desc': 'جرب المنصة مجاناً قبل الاشتراك',
  'value.guarantee.title': 'ضمان الرضا',
  'value.guarantee.desc': 'استرداد كامل خلال 7 أيام',
  'value.support.title': 'دعم مستمر',
  'value.support.desc': 'فريق دعم متاح دائماً لمساعدتك',

  // Process Steps
  'process.title': 'كيف تبدأ رحلتك معنا؟',
  'process.subtitle': '4 خطوات بسيطة تفصلك عن تعلم القرآن',

  'process.step1.title': 'أنشئ حسابك',
  'process.step1.desc': 'سجل مجاناً في دقيقة واحدة وأكمل ملفك الشخصي',

  'process.step2.title': 'اختر معلمك',
  'process.step2.desc': 'تصفح ملفات المعلمين واختر الأنسب لك ولأهدافك',

  'process.step3.title': 'احجز جلستك',
  'process.step3.desc': 'اختر الوقت المناسب واحجز جلستك الأولى المجانية',

  'process.step4.title': 'ابدأ التعلم',
  'process.step4.desc': 'انضم للفصل الافتراضي وابدأ رحلتك نحو إتقان القرآن',

  // Urgency & Scarcity
  'urgency.limitedSpots': 'الأماكن محدودة!',
  'urgency.spotsLeft': 'بقي {count} مقاعد فقط هذا الشهر',
  'urgency.offer': 'عرض خاص: خصم 20% على الباقة الشهرية',
  'urgency.offerEnds': 'ينتهي العرض خلال',

  // For Teachers Page
  'forTeachers.title': 'انضم لفريق معلمينا',
  'forTeachers.subtitle': 'شارك علمك وانفع الأمة من خلال منصة هُدًى للمتقين',

  'forTeachers.benefit1.title': 'دخل مستقر',
  'forTeachers.benefit1.desc': 'احصل على دخل شهري ثابت مع مرونة في تحديد أسعارك وجدولك',

  'forTeachers.benefit2.title': 'طلاب من حول العالم',
  'forTeachers.benefit2.desc': 'تواصل مع طلاب جادين من أكثر من 50 دولة',

  'forTeachers.benefit3.title': 'أدوات احترافية',
  'forTeachers.benefit3.desc': 'منصة متكاملة لإدارة الطلاب والجدول والمدفوعات',

  'forTeachers.benefit4.title': 'دعم مستمر',
  'forTeachers.benefit4.desc': 'فريق متخصص لمساعدتك في كل خطوة',

  'forTeachers.cta': 'قدم طلب الانضمام',
  'forTeachers.requirements': 'المتطلبات: إجازة في القرآن + خبرة 3 سنوات على الأقل',

  // ===========================================
  // Auth — Login Page
  // ===========================================
  'auth.login.success.title': 'تم تسجيل الدخول بنجاح',
  'auth.login.success.desc': 'أهلاً بعودتك!',
  'auth.login.error.title': 'فشل تسجيل الدخول',
  'auth.login.error.credentials': 'يرجى التحقق من بياناتك.',
  'auth.login.error.generic': 'حدث خطأ. يرجى المحاولة مرة أخرى.',
  'auth.login.heading': 'مرحبًا بعودتك',
  'auth.login.subheading': 'سجل دخولك إلى حسابك في هُدًى للمتقين',
  'auth.login.email.placeholder': 'أدخل بريدك الإلكتروني',
  'auth.login.password.label': 'كلمة المرور',
  'auth.login.password.placeholder': 'أدخل كلمة المرور',
  'auth.login.password.show': 'إظهار كلمة المرور',
  'auth.login.password.hide': 'إخفاء كلمة المرور',
  'auth.login.forgotPassword': 'نسيت كلمة المرور؟',
  'auth.login.signingIn': 'جارٍ تسجيل الدخول...',
  'auth.login.submit': 'تسجيل الدخول',
  'auth.login.noAccount': 'ليس لديك حساب؟ ',
  'auth.login.register': 'سجل الآن',

  // ===========================================
  // Auth — Register Page
  // ===========================================
  'auth.register.heading': 'انضم إلى مجتمع التعلم',
  'auth.register.subheading': 'أنشئ حسابًا لبدء رحلتك مع هُدًى للمتقين',
  'auth.register.asStudent': 'سجل كطالب',
  'auth.register.studentDesc': 'ابحث عن معلم وابدأ رحلة تعلم القرآن',
  'auth.register.studentBenefit1': 'ابحث عن معلمين مؤهلين',
  'auth.register.studentBenefit2': 'اختر أوقات تعلم مرنة',
  'auth.register.studentBenefit3': 'تتبع تقدمك في التعلم',
  'auth.register.studentBenefit4': 'إدارة المدفوعات',
  'auth.register.asTeacher': 'سجل كمعلم',
  'auth.register.teacherDesc': 'شارك علمك وتواصل مع الطلاب',
  'auth.register.teacherBenefit1': 'أنشئ ملفك التعريفي',
  'auth.register.teacherBenefit2': 'حدد جدول توفرك',
  'auth.register.teacherBenefit3': 'حدد رسومك',
  'auth.register.teacherBenefit4': 'مدفوعات شهرية آمنة',
  'auth.register.asParent': 'سجل كولي أمر',
  'auth.register.parentDesc': 'سجّل أبناءك وتابع تقدمهم من حساب واحد',
  'auth.register.parentBenefit1': 'أضف كل واحد من أبنائك',
  'auth.register.parentBenefit2': 'اختر معلمًا لكل طفل',
  'auth.register.parentBenefit3': 'تابع حفظهم',
  'auth.register.parentBenefit4': 'حساب واحد وفاتورة واحدة',
  'auth.register.haveAccount': 'لديك حساب بالفعل؟ ',
  'auth.register.signIn': 'سجل الدخول هنا',

  // ===========================================
  // المصادقة — نموذج تسجيل ولي الأمر
  // ===========================================
  'auth.parent.title': 'تسجيل ولي الأمر',
  'auth.parent.description': 'أنشئ حساب العائلة، ثم أضف أبناءك واختر معلميهم.',
  'auth.parent.firstName': 'الاسم الأول',
  'auth.parent.lastName': 'اسم العائلة',
  'auth.parent.fullNameAr': 'الاسم الكامل بالعربية',
  'auth.parent.fullNameArOptional': 'الاسم الكامل بالعربية (اختياري)',
  'auth.parent.email': 'البريد الإلكتروني',
  'auth.parent.phone': 'رقم الهاتف',
  'auth.parent.phoneOptional': 'رقم الهاتف (اختياري)',
  'auth.parent.password': 'كلمة المرور',
  'auth.parent.confirmPassword': 'تأكيد كلمة المرور',
  'auth.parent.submit': 'إنشاء حساب العائلة',
  'auth.parent.submitting': 'جارٍ إنشاء الحساب…',
  'auth.parent.terms': 'أوافق على شروط الخدمة وسياسة الخصوصية',
  'auth.parent.termsRequired': 'يرجى قبول الشروط',
  'auth.parent.termsRequiredDesc': 'يجب الموافقة على شروط الخدمة للمتابعة.',
  'auth.parent.passwordMismatch': 'كلمتا المرور غير متطابقتين',
  'auth.parent.passwordMismatchDesc': 'يرجى التأكد من تطابق كلمتي المرور.',
  'auth.parent.passwordTooShort': 'كلمة المرور قصيرة جدًا',
  'auth.parent.passwordTooShortDesc': 'يرجى استخدام ٨ أحرف على الأقل.',
  'auth.parent.success': 'تم إنشاء حساب العائلة',
  'auth.parent.successDesc': 'يمكنك الآن إضافة أبنائك واختيار معلميهم.',
  'auth.parent.verifyDesc': 'يرجى مراجعة بريدك الإلكتروني لتفعيل حسابك ثم تسجيل الدخول.',
  'auth.parent.failed': 'فشل التسجيل',
  'auth.parent.childrenNote': 'لا يحتاج أبناؤك إلى بريد إلكتروني أو كلمة مرور خاصة بهم — أنت تدير كل شيء من حسابك.',
  'auth.parent.haveAccount': 'لديك حساب بالفعل؟ ',
  'auth.parent.signIn': 'تسجيل الدخول',

  // ===========================================
  // Teacher Profile Page
  // ===========================================
  'teacherProfile.notFound.title': 'المعلم غير موجود',
  'teacherProfile.notFound.desc': 'لم نتمكن من العثور على هذا المعلم',
  'teacherProfile.quranTeacherTitle': 'معلم القرآن الكريم',
  'teacherProfile.certifiedQuranTeacher': 'معلم القرآن المعتمد',
  'teacherProfile.backToTeachers': 'العودة للمعلمين',
  'teacherProfile.yearsExp': 'سنة خبرة',
  'teacherProfile.yearsExperience': 'سنوات خبرة',
  'teacherProfile.loginToBook': 'سجل الدخول للحجز',
  'teacherProfile.signupToBook': 'سجل للحجز',
  'teacherProfile.sendMessage': 'أرسل رسالة',
  'teacherProfile.students': 'طالب',
  'teacherProfile.sessions': 'جلسة',
  'teacherProfile.sessionsCompleted': 'جلسة مكتملة',
  'teacherProfile.hr': 'ساعة',
  'teacherProfile.about': 'نبذة عن المعلم',
  'teacherProfile.noBio': 'لا توجد نبذة',
  'teacherProfile.watchVideo': 'شاهد فيديو التعريف',
  'teacherProfile.notSpecified': 'غير محدد',
  'teacherProfile.lessons': 'درس',
  'teacherProfile.free': 'مجاني',
  'teacherProfile.reviews': 'التقييمات',
  'teacherProfile.reviewsCount': 'تقييم',
  'teacherProfile.noReviews': 'لا توجد تقييمات بعد',
  'teacherProfile.trialAvailable': 'الجلسة التجريبية مجانية',
  'teacherProfile.availability': 'أوقات متاحة',
  'teacherProfile.quickInfo': 'معلومات سريعة',
  'teacherProfile.ijazahCertified': 'معلم معتمد بإجازة',
  'teacherProfile.teacherResponse': 'رد المعلم',
  'teacherProfile.outOfStars': 'من 5 نجوم',
  'teacherProfile.ratingAriaLabel': '{rating} من 5 نجوم',
  'teacherProfile.ratingReviewsAriaLabel': '{rating} من 5 نجوم، {count} تقييم',
  'teacherProfile.averageRatingAriaLabel': 'متوسط {rating} من 5 نجوم',

  // ===========================================
  // Booking Flow (Student)
  // ===========================================
  'booking.title': 'حجز جلسة',
  'booking.with': 'مع',
  'booking.toast.success': 'تم إرسال طلب الحجز بنجاح!',
  'booking.toast.failed': 'فشل إرسال الحجز',
  'booking.steps.date': 'اختر التاريخ',
  'booking.steps.time': 'اختر الوقت',
  'booking.steps.details': 'تفاصيل الجلسة',
  'booking.steps.confirm': 'تأكيد',
  'booking.selectDate.title': 'اختر تاريخ الجلسة',
  'booking.selectDate.desc': 'اختر يومًا متاحًا من التقويم',
  'booking.pickTime.title': 'اختر وقت الجلسة',
  'booking.details.title': 'تفاصيل الجلسة',
  'booking.sessionType': 'نوع الجلسة',
  'booking.type.trial': 'تجريبية',
  'booking.type.trialDesc': '30 دقيقة - مجاني',
  'booking.type.regular': 'عادية',
  'booking.type.regularDesc60': '60 دقيقة',
  'booking.type.trialPriceLabel': 'تجريبية - مجاني',
  'booking.duration': 'المدة',
  'booking.minutes': 'دقيقة',
  'booking.messageLabel': 'رسالة للمعلم (اختياري)',
  'booking.messagePlaceholder': 'أخبر المعلم عن أهدافك أو أي طلبات خاصة...',
  'booking.confirmTitle': 'تأكيد الحجز',
  'booking.confirmDesc': 'راجع تفاصيل الحجز قبل الإرسال',
  'booking.teacher': 'المعلم',
  'booking.date': 'التاريخ',
  'booking.time': 'الوقت',
  'booking.typeAndPrice': 'النوع والسعر',
  'booking.yourMessage': 'رسالتك',
  'booking.approvalNotice': 'سيتم إرسال طلب الحجز إلى المعلم للموافقة عليه. ستتلقى إشعارًا عند القبول.',
  'booking.back': 'السابق',

  // ===========================================
  // Teacher Media Library
  // ===========================================
  'teacher.media.title': 'مكتبة الوسائط',
  'teacher.media.itemsInLibrary': 'عنصر في مكتبتك',
  'teacher.media.uploadNew': 'رفع ملف جديد',
  'teacher.media.search.placeholder': 'بحث في المكتبة...',
  'teacher.media.filter.type': 'النوع',
  'teacher.media.filter.allTypes': 'الكل',
  'teacher.media.filter.status': 'الحالة',
  'teacher.media.filter.all': 'الكل',
  'teacher.media.type.audio': 'صوتي',
  'teacher.media.type.video': 'فيديو',
  'teacher.media.status.draft': 'مسودة',
  'teacher.media.status.published': 'منشور',
  'teacher.media.status.unlisted': 'غير مدرج',
  'teacher.media.status.archived': 'مؤرشف',
  'teacher.media.stats.audioFiles': 'ملفات صوتية',
  'teacher.media.stats.videoFiles': 'ملفات فيديو',
  'teacher.media.stats.totalViews': 'إجمالي المشاهدات',
  'teacher.media.stats.totalLikes': 'إجمالي الإعجابات',
  'teacher.media.empty.title': 'لا توجد ملفات وسائط بعد',
  'teacher.media.empty.subtitle': 'ابدأ برفع أول ملف صوتي أو فيديو',
  'teacher.media.empty.upload': 'رفع ملف',
  'teacher.media.pagination.previous': 'السابق',
  'teacher.media.pagination.next': 'التالي',
  'teacher.media.action.edit': 'تعديل',
  'teacher.media.action.publish': 'نشر',
  'teacher.media.action.delete': 'حذف',
  'teacher.media.action.cancel': 'إلغاء',
  'teacher.media.action.upload': 'رفع',
  'teacher.media.action.uploading': 'جاري الرفع...',
  'teacher.media.action.saveChanges': 'حفظ التغييرات',
  'teacher.media.toast.published': 'تم النشر',
  'teacher.media.toast.deleted': 'تم الحذف',
  'teacher.media.toast.uploaded': 'تم رفع الملف بنجاح',
  'teacher.media.toast.uploadFailed': 'فشل الرفع',
  'teacher.media.toast.updated': 'تم التحديث',
  'teacher.media.toast.updateFailed': 'فشل التحديث',
  'teacher.media.confirm.delete': 'هل أنت متأكد من الحذف؟',
  'teacher.media.error.titleRequired': 'العنوان مطلوب',
  'teacher.media.error.fileOrUrl': 'يرجى رفع ملف أو إدخال رابط خارجي',
  'teacher.media.upload.dialogTitle': 'رفع ملف وسائط جديد',
  'teacher.media.upload.clickToUploadFile': 'اضغط لرفع ملف',
  'teacher.media.upload.clickToUploadThumbnail': 'اضغط لرفع صورة مصغرة',
  'teacher.media.edit.dialogTitle': 'تعديل الوسائط',
  'teacher.media.field.titleEn': 'العنوان (إنجليزي)',
  'teacher.media.field.titleEnRequired': 'العنوان (إنجليزي) *',
  'teacher.media.field.titleEnPlaceholder': 'أدخل العنوان بالإنجليزية',
  'teacher.media.field.titleAr': 'العنوان (عربي)',
  'teacher.media.field.titleArPlaceholder': 'أدخل العنوان بالعربية',
  'teacher.media.field.mediaType': 'نوع الوسائط',
  'teacher.media.field.visibility': 'الرؤية',
  'teacher.media.field.status': 'الحالة',
  'teacher.media.field.mediaFileRequired': 'ملف الوسائط *',
  'teacher.media.field.externalUrl': 'أو رابط خارجي',
  'teacher.media.field.externalUrlPlaceholder': 'رابط يوتيوب أو رابط خارجي',
  'teacher.media.field.thumbnail': 'الصورة المصغرة',
  'teacher.media.field.duration': 'المدة (بالثواني)',
  'teacher.media.field.descriptionEn': 'الوصف (إنجليزي)',
  'teacher.media.field.descriptionAr': 'الوصف (عربي)',
  'teacher.media.field.seoKeywords': 'كلمات مفتاحية SEO',
  'teacher.media.field.seoKeywordsPlaceholder': 'كلمات مفتاحية مفصولة بفواصل',
  'teacher.media.field.tags': 'العلامات',
  'teacher.media.visibility.public': 'عام',
  'teacher.media.visibility.loginRequired': 'يتطلب تسجيل دخول',
  'teacher.media.visibility.private': 'خاص',

  // Teacher Courses (create/edit)
  'teacher.courses.subtitle': 'إنشاء وإدارة دوراتك',
  'teacher.courses.empty.title': 'لا توجد دورات بعد',
  'teacher.courses.empty.description': 'أنشئ دورتك الأولى لبدء تعليم الطلاب على المنصة.',
  'teacher.courses.create.dialogTitle': 'إنشاء دورة',
  'teacher.courses.edit.dialogTitle': 'تحرير الدورة',
  'teacher.courses.field.titleEnRequired': 'العنوان (إنجليزي) *',
  'teacher.courses.field.titleEnPlaceholder': 'أدخل عنوان الدورة بالإنجليزية',
  'teacher.courses.field.titleAr': 'العنوان (عربي)',
  'teacher.courses.field.titleArPlaceholder': 'أدخل عنوان الدورة بالعربية',
  'teacher.courses.field.category': 'التصنيف',
  'teacher.courses.field.level': 'المستوى',
  'teacher.courses.field.shortDescEn': 'وصف مختصر (إنجليزي)',
  'teacher.courses.field.shortDescAr': 'وصف مختصر (عربي)',
  'teacher.courses.field.descEn': 'الوصف (إنجليزي)',
  'teacher.courses.field.descAr': 'الوصف (عربي)',
  'teacher.courses.field.thumbnail': 'الصورة المصغرة',
  'teacher.courses.field.clickToUploadThumbnail': 'انقر لرفع الصورة المصغرة',
  'teacher.courses.field.free': 'دورة مجانية',
  'teacher.courses.field.price': 'السعر (دولار أمريكي)',
  'teacher.courses.action.create': 'إنشاء',
  'teacher.courses.action.saveChanges': 'حفظ التغييرات',
  'teacher.courses.action.saving': 'جارٍ الحفظ...',
  'teacher.courses.toast.created': 'تم إنشاء الدورة كمسودة. ستظهر للطلاب بعد مراجعة الإدارة.',
  'teacher.courses.toast.updated': 'تم تحديث الدورة بنجاح',
  'teacher.courses.toast.saveFailed': 'فشل حفظ الدورة',
  'teacher.courses.toast.uploadFailed': 'فشل رفع الصورة المصغرة',
  'teacher.courses.error.titleRequired': 'العنوان (إنجليزي) مطلوب',
  'teacher.courses.status.draft': 'مسودة',
  'teacher.courses.status.pendingReview': 'قيد المراجعة',
  'teacher.courses.status.published': 'منشورة',
  'teacher.courses.status.archived': 'مؤرشفة',
  'teacher.courses.category.quran': 'القرآن الكريم',
  'teacher.courses.category.tajweed': 'التجويد',
  'teacher.courses.category.memorization': 'الحفظ',
  'teacher.courses.category.arabicLanguage': 'اللغة العربية',
  'teacher.courses.category.islamicStudies': 'الدراسات الإسلامية',
  'teacher.courses.category.quranicArabic': 'العربية القرآنية',
  'teacher.courses.category.tafseer': 'التفسير',
  'teacher.courses.category.other': 'أخرى',
  'teacher.courses.level.beginner': 'مبتدئ',
  'teacher.courses.level.intermediate': 'متوسط',
  'teacher.courses.level.advanced': 'متقدم',
  'teacher.courses.level.allLevels': 'جميع المستويات',

  // Cookie Consent Banner (P7.4.3)
  'cookies.title': 'نحن نحترم خصوصيتك',
  'cookies.message': 'نستخدم ملفات تعريف الارتباط لتحسين تجربتك وتحليل استخدام الموقع. ملفات الارتباط الأساسية مفعّلة دائماً. يمكنك اختيار الفئات الأخرى التي تسمح بها.',
  'cookies.acceptAll': 'قبول الكل',
  'cookies.rejectNonEssential': 'رفض غير الأساسية',
  'cookies.customize': 'تخصيص',
  'cookies.save': 'حفظ التفضيلات',
  'cookies.essential': 'أساسية',
  'cookies.essentialDesc': 'مطلوبة لعمل الموقع ولا يمكن تعطيلها.',
  'cookies.analytics': 'تحليلات',
  'cookies.analyticsDesc': 'تساعدنا على فهم كيفية تفاعل الزوار مع الموقع.',
  'cookies.marketing': 'تسويق',
  'cookies.marketingDesc': 'تُستخدم لعرض إعلانات ذات صلة وتتبع أداء الحملات.',
  'cookies.privacyPolicyLink': 'سياسة الخصوصية',

  // Admin Dashboard (P3.1.2 batch 4)
  'admin.dashboard.subtitle': 'نظرة عامة على المنصة',
  'admin.dashboard.stat.sessions': 'الجلسات',
  'admin.dashboard.stat.revenue': 'الإيرادات',
  'admin.dashboard.stat.completed': 'مكتملة',
  'admin.dashboard.stat.pending': 'معلق',
  'admin.dashboard.stat.commission': 'العمولة:',
  'admin.dashboard.secondary.pendingApprovals': 'معلمون جدد',
  'admin.dashboard.secondary.reviewApplications': 'مراجعة الطلبات',
  'admin.dashboard.secondary.pendingPayments': 'مدفوعات معلقة',
  'admin.dashboard.secondary.verifyPayments': 'التحقق من المدفوعات',
  'admin.dashboard.secondary.totalTeachers': 'إجمالي المعلمين',
  'admin.dashboard.secondary.manageTeachers': 'إدارة المعلمين',
  'admin.dashboard.pending.title': 'طلبات التسجيل المعلقة',
  'admin.dashboard.pending.desc': 'المعلمون بانتظار الموافقة',
  'admin.dashboard.pending.noSpecialty': 'لم يحدد التخصص',
  'admin.dashboard.pending.review': 'مراجعة',
  'admin.dashboard.pending.viewAll': 'عرض الكل',
  'admin.dashboard.pending.empty': 'لا توجد طلبات معلقة',
  'admin.dashboard.revenue.title': 'نظرة على الإيرادات',
  'admin.dashboard.revenue.last30days': 'آخر 30 يوم',
  'admin.dashboard.revenue.totalRevenue': 'إجمالي الإيرادات',
  'admin.dashboard.revenue.platformCommission': 'عمولة المنصة',
  'admin.dashboard.revenue.teacherPayouts': 'مدفوعات للمعلمين',
  'admin.dashboard.revenue.sessionsCount': 'عدد الجلسات',
  'admin.dashboard.revenue.detailedReport': 'تقرير مفصل',
  'admin.dashboard.revenue.noData': 'لا توجد بيانات',
  'admin.dashboard.quickActions.title': 'إجراءات سريعة',
  'admin.dashboard.quickActions.finance': 'المالية',
  'admin.dashboard.quickActions.analytics': 'التحليلات',
  'admin.dashboard.quickActions.institutions': 'المؤسسات',
  'admin.dashboard.quickActions.cms': 'إدارة المحتوى',

  // Admin Refunds (P3.1.2 batch 4)
  'admin.refunds.toast.approved': 'تمت الموافقة',
  'admin.refunds.toast.processed': 'تمت المعالجة',
  'admin.refunds.toast.rejected': 'تم الرفض',
  'admin.refunds.title': 'إدارة الاستردادات',
  'admin.refunds.subtitle': 'مراجعة ومعالجة طلبات الاسترداد',
  'admin.refunds.stat.total': 'الإجمالي',
  'admin.refunds.stat.pending': 'قيد الانتظار',
  'admin.refunds.stat.completed': 'المكتملة',
  'admin.refunds.stat.totalRefunded': 'إجمالي المسترد',
  'admin.refunds.filter.allStatus': 'جميع الحالات',
  'admin.refunds.filter.approved': 'موافق عليه',
  'admin.refunds.filter.rejected': 'مرفوض',
  'admin.refunds.col.ref': 'المرجع',
  'admin.refunds.col.student': 'الطالب',
  'admin.refunds.col.teacher': 'المعلم',
  'admin.refunds.col.amount': 'المبلغ',
  'admin.refunds.col.reason': 'السبب',
  'admin.refunds.col.status': 'الحالة',
  'admin.refunds.col.date': 'التاريخ',
  'admin.refunds.col.actions': 'إجراءات',
  'admin.refunds.action.approve': 'موافقة',
  'admin.refunds.action.reject': 'رفض',
  'admin.refunds.action.process': 'معالجة',
  'admin.refunds.empty.title': 'لا توجد استردادات',
  'admin.refunds.empty.desc': 'لا توجد طلبات استرداد حالياً',
  'admin.refunds.dialog.approve': 'الموافقة على الاسترداد',
  'admin.refunds.dialog.process': 'معالجة الاسترداد',
  'admin.refunds.dialog.reject': 'رفض الاسترداد',
  'admin.refunds.dialog.reasonPlaceholder': 'سبب الرفض...',

  // Admin Finance (P3.1.2 batch 4)
  'admin.finance.stat.totalRevenue': 'إجمالي الإيرادات',
  'admin.finance.stat.netProfit': 'صافي الربح',
  'admin.finance.stat.transactions': 'المعاملات',
  'admin.finance.stat.avgValue': 'متوسط القيمة',
  'admin.finance.title': 'الإدارة المالية',
  'admin.finance.subtitle': 'الإيرادات والمعاملات والمدفوعات',
  'admin.finance.refunds': 'الاستردادات',
  'admin.finance.scholarships': 'المنح',
  'admin.finance.period.week': 'أسبوع',
  'admin.finance.period.month': 'شهر',
  'admin.finance.period.quarter': 'ربع',
  'admin.finance.period.year': 'سنة',
  'admin.finance.vsPrev': 'مقارنة بالفترة السابقة',
  'admin.finance.recentTransactions': 'المعاملات الأخيرة',
  'admin.finance.filter.allStatus': 'جميع الحالات',
  'admin.finance.filter.completed': 'مكتمل',
  'admin.finance.filter.pending': 'قيد الانتظار',
  'admin.finance.filter.failed': 'فشل',
  'admin.finance.filter.refunded': 'مسترد',
  'admin.finance.col.reference': 'المرجع',
  'admin.finance.col.student': 'الطالب',
  'admin.finance.col.amount': 'المبلغ',
  'admin.finance.col.method': 'الطريقة',
  'admin.finance.col.status': 'الحالة',
  'admin.finance.col.date': 'التاريخ',

  // Teacher Schedule (P3.1.2 batch 5)
  'teacher.schedule.subtitle': 'إدارة جلساتك وجدول توفرك',
  'teacher.schedule.daysWithSessions': 'أيام بها جلسات',
  'teacher.schedule.sessionsCount': 'جلسة',
  'teacher.schedule.minutes': 'دقيقة',
  'teacher.schedule.toast.savedTitle': 'تم الحفظ',
  'teacher.schedule.toast.savedDesc': 'تم تحديث جدول التوفر بنجاح',
  'teacher.schedule.toast.saveFailed': 'فشل في حفظ جدول التوفر',
  'teacher.schedule.toast.completedTitle': 'تم إكمال الجلسة',
  'teacher.schedule.toast.completedDesc': 'تم وضع علامة على الجلسة كمكتملة',
  'teacher.schedule.toast.completeFailed': 'فشل في إكمال الجلسة',
  'teacher.schedule.toast.cancelledTitle': 'تم إلغاء الجلسة',
  'teacher.schedule.toast.cancelledDesc': 'تم إلغاء الجلسة بنجاح',
  'teacher.schedule.toast.cancelFailed': 'فشل في إلغاء الجلسة',
  'teacher.schedule.toast.updatedTitle': 'تم التحديث',
  'teacher.schedule.toast.updatedDesc': 'تم تحديث الجلسة بنجاح',
  'teacher.schedule.toast.updateFailed': 'فشل في تحديث الجلسة',
  'teacher.schedule.status.scheduled': 'مجدول',
  'teacher.schedule.status.inProgress': 'جاري',
  'teacher.schedule.status.completed': 'مكتمل',
  'teacher.schedule.status.cancelled': 'ملغي',
  'teacher.schedule.status.noShow': 'لم يحضر',
  'teacher.schedule.action.start': 'بدء',
  'teacher.schedule.action.complete': 'إكمال',
  'teacher.schedule.action.addSlot': 'إضافة فترة توفر',
  'teacher.schedule.action.saving': 'جاري الحفظ...',
  'teacher.schedule.action.saveChanges': 'حفظ التغييرات',
  'teacher.schedule.action.goBack': 'تراجع',
  'teacher.schedule.action.cancelling': 'جاري الإلغاء...',
  'teacher.schedule.action.confirmCancel': 'تأكيد الإلغاء',
  'teacher.schedule.dialog.manageAvailability': 'إدارة جدول التوفر',
  'teacher.schedule.dialog.manageAvailabilityDesc': 'حدد الأوقات التي تكون فيها متاحاً للتدريس',
  'teacher.schedule.dialog.editSession': 'تعديل الجلسة',
  'teacher.schedule.dialog.cancelSession': 'إلغاء الجلسة',
  'teacher.schedule.dialog.cancelSessionDesc': 'هل أنت متأكد من إلغاء هذه الجلسة؟ سيتم إخطار الطالب.',
  'teacher.schedule.empty.noSlots': 'لا توجد فترات توفر محددة',
  'teacher.schedule.day.monday': 'الاثنين',
  'teacher.schedule.day.tuesday': 'الثلاثاء',
  'teacher.schedule.day.wednesday': 'الأربعاء',
  'teacher.schedule.day.thursday': 'الخميس',
  'teacher.schedule.day.friday': 'الجمعة',
  'teacher.schedule.day.saturday': 'السبت',
  'teacher.schedule.day.sunday': 'الأحد',
  'teacher.schedule.field.meetingLink': 'رابط الاجتماع',
  'teacher.schedule.field.notes': 'ملاحظات',
  'teacher.schedule.placeholder.notes': 'ملاحظات للطالب...',
  'teacher.schedule.placeholder.cancelReason': 'سبب الإلغاء...',

  // Admin Scholarships (P3.1.2 batch 5)
  'admin.scholarships.toast.updated': 'تم تحديث المنحة',
  'admin.scholarships.toast.error': 'حدث خطأ',
  'admin.scholarships.title': 'إدارة المنح الدراسية',
  'admin.scholarships.subtitle': 'مراجعة وإدارة طلبات المنح',
  'admin.scholarships.stat.total': 'الإجمالي',
  'admin.scholarships.stat.pending': 'قيد الانتظار',
  'admin.scholarships.stat.approved': 'الموافق عليها',
  'admin.scholarships.stat.totalAmount': 'إجمالي المبلغ',
  'admin.scholarships.filter.allStatus': 'جميع الحالات',
  'admin.scholarships.filter.pending': 'قيد الانتظار',
  'admin.scholarships.filter.underReview': 'قيد المراجعة',
  'admin.scholarships.filter.approved': 'موافق',
  'admin.scholarships.filter.rejected': 'مرفوض',
  'admin.scholarships.type.needBased': 'حسب الحاجة',
  'admin.scholarships.type.meritBased': 'حسب الجدارة',
  'admin.scholarships.type.hafiz': 'حافظ',
  'admin.scholarships.type.community': 'مجتمعية',
  'admin.scholarships.type.full': 'كاملة',
  'admin.scholarships.action.approve': 'موافقة',
  'admin.scholarships.action.reject': 'رفض',
  'admin.scholarships.empty.title': 'لا توجد منح',
  'admin.scholarships.empty.desc': 'لا توجد طلبات منح حالياً',
  'admin.scholarships.dialog.approveTitle': 'الموافقة على المنحة',
  'admin.scholarships.dialog.rejectTitle': 'رفض المنحة',
  'admin.scholarships.field.amount': 'المبلغ ($)',
  'admin.scholarships.field.notes': 'ملاحظات',
  'admin.scholarships.placeholder.rejectReason': 'سبب الرفض...',
  'admin.scholarships.placeholder.reviewNotes': 'ملاحظات المراجعة...',

  // Admin Analytics (P3.1.2 batch 5)
  'admin.analytics.title': 'تحليلات المنصة',
  'admin.analytics.subtitle': 'رؤى شاملة حول أداء المنصة',
  'admin.analytics.period.week': 'أسبوع',
  'admin.analytics.period.month': 'شهر',
  'admin.analytics.period.year': 'سنة',
  'admin.analytics.tab.overview': 'نظرة عامة',
  'admin.analytics.tab.revenue': 'الإيرادات',
  'admin.analytics.tab.sessions': 'الجلسات',
  'admin.analytics.tab.teachers': 'المعلمون',
  'admin.analytics.tab.hifz': 'الحفظ',
  'admin.analytics.teachers.title': 'استخدام المعلمين',
  'admin.analytics.teachers.active': 'المعلمون النشطون',
  'admin.analytics.teachers.avgUtilization': 'متوسط الاستخدام',
  'admin.analytics.teachers.sessions': 'جلسة',

  // P3.1.2 batch 6 — TeacherEarnings
  'teacherEarnings.title': 'الأرباح والمدفوعات',
  'teacherEarnings.subtitle': 'تتبع أرباحك ومدفوعاتك',
  'teacherEarnings.period.week': 'هذا الأسبوع',
  'teacherEarnings.period.month': 'هذا الشهر',
  'teacherEarnings.period.year': 'هذا العام',
  'teacherEarnings.period.allTime': 'الكل',
  'teacherEarnings.stats.totalEarnings': 'إجمالي الأرباح',
  'teacherEarnings.stats.netIncome': 'صافي الدخل',
  'teacherEarnings.stats.sessionsCompleted': 'الجلسات المكتملة',
  'teacherEarnings.stats.pendingPayout': 'في الانتظار',
  'teacherEarnings.breakdown.title': 'تفاصيل الأرباح',
  'teacherEarnings.breakdown.subtitle': 'مصادر الدخل',
  'teacherEarnings.breakdown.individual': 'جلسات فردية',
  'teacherEarnings.breakdown.packages': 'الحزم',
  'teacherEarnings.breakdown.group': 'الحلقات الجماعية',
  'teacherEarnings.breakdown.commission': 'عمولة المنصة',
  'teacherEarnings.payouts.title': 'المدفوعات الأخيرة',
  'teacherEarnings.payouts.subtitle': 'سجل المدفوعات',
  'teacherEarnings.payouts.empty.title': 'لا توجد مدفوعات بعد',
  'teacherEarnings.payouts.empty.desc': 'ستظهر مدفوعاتك هنا',
  'teacherEarnings.avgPerHour.label': 'الأرباح لكل ساعة (متوسط)',
  'teacherEarnings.avgPerHour.note': 'بعد خصم العمولة',

  // P3.1.2 batch 6 — StudentCourses (sessions page)
  'studentCourses.subtitle': 'عرض وإدارة جلساتك',
  'studentCourses.status.scheduled': 'مجدول',
  'studentCourses.status.inProgress': 'جاري',
  'studentCourses.status.completed': 'مكتمل',
  'studentCourses.status.cancelled': 'ملغي',
  'studentCourses.status.noShow': 'لم يحضر',
  'studentCourses.tabs.upcoming': 'القادمة',
  'studentCourses.tabs.completed': 'المكتملة',
  'studentCourses.tabs.all': 'الكل',
  'studentCourses.duration.min': 'دقيقة',
  'studentCourses.action.join': 'انضم',
  'studentCourses.action.rate': 'تقييم',
  'studentCourses.empty.upcoming': 'لا توجد جلسات قادمة',
  'studentCourses.empty.completed': 'لا توجد جلسات مكتملة',
  'studentCourses.empty.all': 'لا توجد جلسات بعد',
  'studentCourses.rating.title': 'تقييم الجلسة',
  'studentCourses.rating.description': 'كيف كانت تجربتك مع هذه الجلسة؟',
  'studentCourses.rating.select': 'اختر تقييمك',
  'studentCourses.rating.excellent': 'ممتاز!',
  'studentCourses.rating.veryGood': 'جيد جداً',
  'studentCourses.rating.good': 'جيد',
  'studentCourses.rating.fair': 'مقبول',
  'studentCourses.rating.poor': 'ضعيف',
  'studentCourses.rating.placeholder': 'أضف ملاحظاتك (اختياري)...',
  'studentCourses.rating.submitting': 'جاري الإرسال...',
  'studentCourses.rating.submit': 'إرسال التقييم',
  'studentCourses.toast.rated': 'شكراً لتقييمك!',
  'studentCourses.toast.ratedDesc': 'تم حفظ تقييمك بنجاح',
  'studentCourses.toast.rateFailed': 'فشل في حفظ التقييم',

  // P3.1.2 batch 7 — StudentProfile
  'studentProfile.subtitle': 'إدارة معلوماتك الشخصية',
  'studentProfile.stats.totalSessions': 'إجمالي الجلسات',
  'studentProfile.stats.learningHours': 'ساعات التعلم',
  'studentProfile.stats.coursesEnrolled': 'الدورات المسجلة',
  'studentProfile.stats.totalSpent': 'إجمالي الإنفاق',
  'studentProfile.timezone.placeholder': 'اختر المنطقة الزمنية',
  'studentProfile.preferences.title': 'تفضيلات التعلم',
  'studentProfile.preferences.subtitle': 'أخبرنا عن أهدافك التعليمية',
  'studentProfile.preferences.level': 'المستوى الحالي',
  'studentProfile.preferences.lang': 'لغة التعليم المفضلة',
  'studentProfile.preferences.duration': 'مدة الجلسة المفضلة',
  'studentProfile.preferences.interests': 'اهتماماتك التعليمية',
  'studentProfile.preferences.interestsPlaceholder': 'القرآن، التجويد، اللغة العربية...',
  'studentProfile.preferences.interestsHint': 'افصل بين الاهتمامات بفواصل',
  'studentProfile.preferences.goals': 'أهدافك التعليمية',
  'studentProfile.preferences.goalsPlaceholder': 'ما الذي تريد تحقيقه من خلال دراستك؟',
  'studentProfile.lang.arabic': 'العربية',
  'studentProfile.lang.english': 'الإنجليزية',
  'studentProfile.lang.urdu': 'الأردية',
  'studentProfile.lang.indonesian': 'الإندونيسية',
  'studentProfile.duration.minutes': 'دقيقة',
  'studentProfile.memberSince': 'عضو منذ',

  // P3.1.2 batch 8 — Courses listing page
  'courses.page.title': 'الدورات التعليمية',
  'courses.page.subtitle': 'اكتشف دوراتنا المنظمة في التجويد والحفظ والتفسير واللغة العربية',
  'courses.filter.heading': 'تصفية النتائج',
  'courses.filter.searchPlaceholder': 'ابحث عن دورة...',
  'courses.filter.searchAriaLabel': 'البحث عن الدورات',
  'courses.filter.allCategories': 'جميع الفئات',
  'courses.filter.allLevels': 'جميع المستويات',
  'courses.card.viewCourse': 'عرض الدورة',
  'courses.error.title': 'خطأ في تحميل الدورات',
  'courses.error.description': 'يرجى المحاولة مرة أخرى لاحقًا',
  'courses.empty.title': 'لا توجد دورات',
  'courses.empty.description': 'جرب تغيير معايير البحث',
  'courses.rating.outOf5Stars': 'من 5 نجوم',
  'courses.rating.reviews': 'تقييم',
  'courses.pagination.showing': 'عرض',
  'courses.pagination.of': 'من',
  'courses.pagination.coursesNoun': 'دورة',

  // P3.1.2 batch 8 — FamilyDashboard
  'family.toast.accountCreated': 'تم إنشاء حساب العائلة',
  'family.toast.childAdded': 'تمت إضافة الطفل',
  'family.toast.childRemoved': 'تمت إزالة الطفل',
  'family.createAccount.title': 'أنشئ حساب عائلة',
  'family.createAccount.description': 'أنشئ حسابًا عائليًا لإدارة تعلم أطفالك ومتابعة تقدمهم في مكان واحد.',
  'family.createAccount.button': 'إنشاء حساب عائلة',
  'family.stats.children': 'الأطفال',
  'family.stats.totalSessions': 'إجمالي الجلسات',
  'family.stats.surahsMemorized': 'السور المحفوظة',
  'family.stats.totalSpent': 'إجمالي الإنفاق',
  'family.children.heading': 'أطفالي',
  'family.children.addChild': 'إضافة طفل',
  'family.children.empty.title': 'لا يوجد أطفال بعد',
  'family.children.empty.description': 'أضف طفلك الأول لبدء رحلة التعلم',
  'family.children.completed': 'جلسات مكتملة:',
  'family.children.surahs': 'سور',
  'family.children.streak': 'سلسلة',
  'family.children.upcoming': 'قادمة',
  'family.dialog.title': 'إضافة طفل',
  'family.dialog.subtitle': 'أدخل معلومات طفلك',
  'family.dialog.nameEn': 'الاسم (بالإنجليزية)',
  'family.dialog.nameAr': 'الاسم (بالعربية)',
  'family.dialog.namePlaceholder': 'اسم الطفل',
  'family.dialog.dateOfBirth': 'تاريخ الميلاد',
  'family.dialog.learningLevel': 'مستوى التعلم',
  'family.dialog.addButton': 'إضافة',
  'family.heading': 'لوحة العائلة',
  'family.subheading': 'أدر تعلّم أبنائك من مكان واحد',
  'family.stats.ayahs': 'الآيات المحفوظة',
  'family.stats.upcoming': 'الجلسات القادمة',
  'family.dialog.gender': 'الجنس',
  'family.dialog.genderMale': 'ولد',
  'family.dialog.genderFemale': 'بنت',
  'family.dialog.levelHafiz': 'حافظ',
  'family.dialog.teacher': 'المعلم',
  'family.dialog.teacherPlaceholder': 'اختر معلمًا',
  'family.dialog.teacherNone': 'أقرر لاحقًا',
  'family.dialog.teacherHelp': 'يمكنك تغيير ذلك في أي وقت.',
  'family.dialog.nameRequired': 'يرجى إدخال اسم الطفل',
  'family.children.teacher': 'المعلم',
  'family.children.noTeacher': 'لم يتم اختيار معلم بعد',
  'family.children.chooseTeacher': 'اختر معلمًا',
  'family.children.changeTeacher': 'تغيير المعلم',
  'family.children.book': 'احجز جلسة',
  'family.children.remove': 'إزالة الطفل',
  'family.children.removeConfirm': 'هل تريد إزالة هذا الطفل من حساب العائلة؟',
  'family.children.ayahs': 'آية',
  'family.children.pendingReviews': 'مراجعات مستحقة',
  'family.children.nextSession': 'الجلسة القادمة',
  'family.children.noSessions': 'لا توجد جلسات محجوزة',
  'family.teacherDialog.title': 'اختر معلمًا',
  'family.teacherDialog.subtitle': 'اختر المعلم الذي سيعمل مع',
  'family.teacherDialog.search': 'ابحث عن معلم…',
  'family.teacherDialog.empty': 'لا يوجد معلمون مطابقون لبحثك',
  'family.teacherDialog.assign': 'تعيين',
  'family.teacherDialog.clear': 'إزالة المعلم',
  'family.teacherDialog.perHour': '/ساعة',
  'family.toast.teacherAssigned': 'تم تحديث المعلم',
  'family.toast.error': 'حدث خطأ ما',
  'family.loginPrompt': 'سجّل الدخول إلى حساب عائلتك للمتابعة.',

  // ===========================================
  // المعلم — بيانات الاستلام
  // ===========================================
  'payout.nav': 'بيانات الاستلام',
  'payout.heading': 'بيانات استلام الأرباح',
  'payout.subheading': 'أخبرنا أين نرسل أرباحك',
  'payout.method': 'طريقة الاستلام',
  'payout.methodHelp': 'اختر الطريقة التي تفضل استلام أموالك بها. يمكنك تغييرها في أي وقت.',
  'payout.method.bank': 'تحويل بنكي',
  'payout.method.paypal': 'باي بال',
  'payout.method.wise': 'وايز',
  'payout.method.westernUnion': 'ويسترن يونيون',
  'payout.method.moneyGram': 'موني جرام',
  'payout.method.mobileWallet': 'محفظة إلكترونية',
  'payout.bankName': 'اسم البنك',
  'payout.bankAccountName': 'اسم صاحب الحساب',
  'payout.bankAccountNumber': 'رقم الحساب',
  'payout.bankIban': 'رقم الآيبان',
  'payout.bankSwift': 'رمز السويفت / BIC',
  'payout.bankCountry': 'دولة البنك',
  'payout.paypalEmail': 'بريد باي بال الإلكتروني',
  'payout.wiseEmail': 'بريد وايز الإلكتروني',
  'payout.recipientName': 'الاسم الكامل كما في الهوية',
  'payout.recipientNameHelp': 'كما هو مكتوب في هويتك تمامًا — سيُرفض التحويل إذا لم يتطابق.',
  'payout.recipientCountry': 'الدولة',
  'payout.recipientCity': 'المدينة',
  'payout.recipientPhone': 'رقم الهاتف',
  'payout.walletProvider': 'مزود المحفظة',
  'payout.walletNumber': 'رقم المحفظة',
  'payout.save': 'حفظ بيانات الاستلام',
  'payout.saving': 'جارٍ الحفظ…',
  'payout.saved': 'تم حفظ بيانات الاستلام',
  'payout.saveFailed': 'تعذر حفظ بيانات الاستلام',
  'payout.incomplete': 'بيانات الاستلام غير مكتملة — لا يمكننا تحويل أرباحك حتى تُستكمل.',
  'payout.complete': 'بيانات الاستلام مكتملة.',
  'payout.privacyNote': 'هذه البيانات تظهر لك ولفريق المالية فقط، ولا تُعرض أبدًا في ملفك العام.',
  'payout.optional': 'اختياري',

  // ===========================================
  // الإدارة — مستحقات المعلمين
  // ===========================================
  'adminPayouts.heading': 'مستحقات المعلمين',
  'adminPayouts.subheading': 'شغّل دفعات الشهر، وتحقق من وجهة كل دفعة، وسجّل التحويل',
  'adminPayouts.runMonth': 'إنشاء دفعات الشهر الماضي',
  'adminPayouts.generated': 'تم إنشاء الدفعات',
  'adminPayouts.blockedSuffix': 'متوقفة بسبب بيانات ناقصة',
  'adminPayouts.unpayableWarning': 'دفعة لا يمكن تحويلها — لم يستكمل المعلم بياناته.',
  'adminPayouts.filterStatus': 'تصفية حسب الحالة',
  'adminPayouts.allStatuses': 'كل الحالات',
  'adminPayouts.total': 'دفعة',
  'adminPayouts.sessions': 'جلسة',
  'adminPayouts.gross': 'الإجمالي',
  'adminPayouts.noDetails': 'لا توجد بيانات استلام',
  'adminPayouts.viewDestination': 'وجهة التحويل',
  'adminPayouts.refreshDetails': 'تحديث البيانات',
  'adminPayouts.detailsRefreshed': 'تم تحديث بيانات الاستلام',
  'adminPayouts.stillIncomplete': 'لم يستكمل المعلم بياناته بعد',
  'adminPayouts.approve': 'اعتماد',
  'adminPayouts.approved': 'تم اعتماد الدفعة',
  'adminPayouts.cannotApprove': 'لا يمكن الاعتماد حتى يستكمل المعلم بيانات الاستلام.',
  'adminPayouts.markPaid': 'تسجيل كمدفوعة',
  'adminPayouts.markedPaid': 'تم تسجيل الدفعة كمدفوعة',
  'adminPayouts.confirmPaid': 'تأكيد الدفع',
  'adminPayouts.reference': 'مرجع العملية',
  'adminPayouts.referenceHelp': 'مرجع التحويل البنكي — هذا هو الرابط الوحيد بين هذا السجل والتحويل الفعلي.',
  'adminPayouts.destinationTitle': 'وجهة تحويل هذه الدفعة',
  'adminPayouts.noDestination': 'لم تُسجَّل وجهة',
  'adminPayouts.empty.title': 'لا توجد دفعات بعد',
  'adminPayouts.empty.description': 'أنشئ دفعات الشهر الماضي للمعلمين الذين لديهم جلسات مدفوعة',
  'adminPayouts.error': 'حدث خطأ ما',
  'adminPayouts.prev': 'الصفحة السابقة',
  'adminPayouts.next': 'الصفحة التالية',


  // P3.1.2 batch 9 — CourseDetail
  'courseDetail.toast.enrollSuccess': 'تم التسجيل بنجاح!',
  'courseDetail.toast.enrollFailed': 'فشل التسجيل',
  'courseDetail.seo.description': 'دورة قرآنية مع معلم معتمد',
  'courseDetail.notFound.title': 'الدورة غير موجودة',
  'courseDetail.notFound.description': 'لم نتمكن من العثور على هذه الدورة',
  'courseDetail.notFound.action': 'تصفح الدورات',
  'courseDetail.backToCourses': 'العودة للدورات',
  'courseDetail.badge.featured': 'مميز',
  'courseDetail.stats.enrolled': 'طالب',
  'courseDetail.stats.hours': 'ساعة',
  'courseDetail.preview.ariaLabel': 'مشاهدة معاينة الدورة',
  'courseDetail.tabs.description': 'وصف الدورة',
  'courseDetail.tabs.whatYouLearn': 'ماذا ستتعلم',
  'courseDetail.tabs.syllabus': 'المنهج الدراسي',
  'courseDetail.tabs.prerequisites': 'المتطلبات المسبقة',
  'courseDetail.tabs.whoThisIsFor': 'الفئة المستهدفة',
  'courseDetail.lesson.lockedNote': 'تفاصيل الدرس ستكون متاحة بعد التسجيل',
  'courseDetail.pricing.off': 'خصم',
  'courseDetail.pricing.signUpToEnroll': 'سجل للالتحاق',
  'courseDetail.card.lessons': 'الدروس',
  'courseDetail.card.enrolled': 'المسجلين',
  'courseDetail.card.completed': 'أكملوها',

  // Mushaf viewer (Phase 2 — docs/MUSHAF-VIEWER-PLAN.md)
  'mushaf.pageMode': 'صفحة',
  'mushaf.textMode': 'نص',
  'mushaf.page': 'صفحة',
  'mushaf.juz': 'جزء',
  'mushaf.searchSurah': 'بحث عن سورة...',
  'mushaf.nextPage': 'الصفحة التالية',
  'mushaf.prevPage': 'الصفحة السابقة',
  'mushaf.nextSurah': 'السورة التالية',
  'mushaf.prevSurah': 'السورة السابقة',
  'mushaf.translation': 'الترجمة',
  'mushaf.bookmarkPage': 'إضافة علامة لهذه الصفحة',
  'mushaf.bookmarks': 'العلامات',
  'mushaf.playAyah': 'تشغيل الآية',
  'mushaf.repeatAyah': 'تكرار الآية',
  'mushaf.memorized': 'محفوظ',
  'mushaf.inProgress': 'قيد الحفظ',
  'mushaf.needsReview': 'يحتاج مراجعة',
  'mushaf.noAyahs': 'لا توجد آيات متاحة',
  'mushaf.attribution': 'صفحات المصحف من مشروع آيات - جامعة الملك سعود',
  'mushaf.markHifz': 'تسجيل الحفظ',
  'mushaf.fromAyah': 'من الآية',
  'mushaf.toAyah': 'إلى الآية',
  'mushaf.save': 'حفظ',
  'mushaf.hifzSaved': 'تم حفظ تقدم الحفظ',
  'mushaf.hifzSaveFailed': 'تعذر حفظ تقدم الحفظ',
  'mushaf.openInMushaf': 'افتح في المصحف',
  'mushaf.pageAlt': 'صفحة المصحف',
  'mushaf.pauseAyah': 'إيقاف الآية مؤقتًا',
  'send': 'إرسال',
  'unread': 'غير مقروء',
  'chat.studentSubtitle': 'تواصل مع معلميك',
  'chat.teacherSubtitle': 'تواصل مع طلابك',
  'chat.noMessagesYet': 'لا توجد رسائل بعد — ابدأ المحادثة',
  'adminUsers.all': 'الكل',
  'adminUsers.teacher': 'معلم',
  'adminUsers.student': 'طالب',
  'adminUsers.active': 'نشط',
  'adminUsers.approved': 'معتمد',
  'adminUsers.pending': 'قيد المراجعة',
  'adminUsers.rejected': 'مرفوض',
  'adminUsers.suspended': 'موقوف',
  'adminUsers.country': 'الدولة',
  'adminUsers.sessions': 'الجلسات',
  'adminUsers.empty': 'لا يوجد مستخدمون مطابقون',
  'adminUsers.usersSuffix': 'مستخدم',
  'adminUsers.prevPage': 'الصفحة السابقة',
  'adminUsers.nextPage': 'الصفحة التالية',

  // Google sign-in
  'auth.google.continue': 'المتابعة باستخدام Google',
  'auth.google.or': 'أو',
  'auth.google.unavailable': 'تسجيل الدخول عبر Google غير متاح حاليًا',
  'auth.google.callback.completing': 'جارٍ إكمال تسجيل الدخول…',
  'auth.google.callback.chooseRole': 'كيف تودّ الانضمام؟',
  'auth.google.callback.chooseRoleDesc': 'تم ربط حساب Google الخاص بك. اختر كيف تريد استخدام المنصة.',
  'auth.google.callback.asStudent': 'الانضمام كطالب',
  'auth.google.callback.asTeacher': 'التقديم كمعلم',
  'auth.google.callback.pendingTitle': 'تم استلام الطلب',
  'auth.google.callback.pendingDesc': 'طلبك كمعلم قيد المراجعة. سيتم إشعارك عند الموافقة.',
  'auth.google.callback.error': 'فشل تسجيل الدخول عبر Google. حاول مرة أخرى.',
  'auth.google.callback.backToLogin': 'العودة لتسجيل الدخول',
  'auth.google.callback.goHome': 'الذهاب للصفحة الرئيسية',

  // ===========================================
  // صفحة تحفيظ القرآن للأطفال (/quran-for-kids)
  // صفحة هبوط لحملة الأطفال الإعلانية.
  // ===========================================
  'seo.kids.title': 'تحفيظ القرآن للأطفال أونلاين — دروس فردية | هُدًى للمتقين',
  'seo.kids.description': 'دروس قرآن فردية مباشرة للأطفال من 4 إلى 15 سنة. معلمون بإجازات موثّقة، ومعلمات متاحات، وحساب لولي الأمر يبقيك متابعًا لكل خطوة.',
  'seo.kids.keywords': 'تحفيظ القرآن للأطفال, تعليم القرآن للأطفال أونلاين, معلمة قرآن للأطفال, القاعدة النورانية للأطفال, دروس تجويد للأطفال, حفظ القرآن للأطفال عن بعد, تحفيظ قرآن أونلاين للأطفال, معلم قرآن للأطفال',

  'kids.breadcrumb': 'القرآن للأطفال',

  'kids.hero.badge': 'من 4 إلى 15 سنة · دروس فردية',
  'kids.hero.title': 'تحفيظ القرآن للأطفال أونلاين',
  'kids.hero.subtitle': 'دروس فردية مع معلمين متخصصين في تعليم الأطفال — القاعدة النورانية والقراءة والتجويد والحفظ، على قدر مستوى طفلك وفي الأوقات التي تناسب أسرتك.',
  'kids.hero.ctaPrimary': 'أنشئ حساب ولي أمر',
  'kids.hero.ctaSecondary': 'تعرّف على المعلمين',
  'kids.hero.trust1': 'معلمون بإجازات موثّقة',
  'kids.hero.trust2': 'معلمات متاحات للبنات',
  'kids.hero.trust3': 'طفلك لا يحتاج حسابًا خاصًا',
  'kids.hero.trust4': 'دروس فردية دائمًا، لا مجموعات',

  'kids.stats.teachersLabel': 'معلمًا متخصصًا في تعليم الأطفال',
  'kids.stats.agesValue': '15–4',
  'kids.stats.agesLabel': 'الفئة العمرية',
  'kids.stats.ratingLabel': 'متوسط تقييم المعلمين',
  'kids.stats.formatValue': 'فردي',
  'kids.stats.formatLabel': 'كل درس',

  'kids.why.eyebrow': 'لماذا يختار الآباء هُدًى',
  'kids.why.title': 'مصمَّمة للأطفال، ولولي الأمر الذي يحجز الدرس',
  'kids.why.1.title': 'معلمون متخصصون في تعليم الأطفال',
  'kids.why.1.desc': 'أن تُمسك انتباه طفل في السابعة مهارة قائمة بذاتها. كل معلم معروض في هذه الصفحة يذكر تعليم القرآن للأطفال ضمن تخصصاته.',
  'kids.why.2.title': 'معلمات لبناتكم',
  'kids.why.2.desc': 'أكثر معلمي الأطفال لدينا من النساء. وأنت من يختار المعلم بنفسه — لا يُسنَد أحد إلى طفلك دون علمك.',
  'kids.why.3.title': 'طفلك لا يحتاج حسابًا خاصًا',
  'kids.why.3.desc': 'تضيف طفلك ملفًا داخل حسابك أنت. لا كلمة مرور يفقدها، ولا بريد يصله منه غريب.',
  'kids.why.4.title': 'المنهج المناسب للسن المناسبة',
  'kids.why.4.desc': 'يبدأ الصغار بالقاعدة النورانية — الحروف وأصواتها قبل الكلمات. ثم ينتقل الأكبر سنًّا إلى القراءة المتقنة وأحكام التجويد والحفظ.',
  'kids.why.5.title': 'متابعة واضحة للتقدّم',
  'kids.why.5.desc': 'تعرض لوحة الأسرة كل جلسة محجوزة ومكتملة لكل طفل، فتبقى على اطلاع دائم بما وصل إليه.',
  'kids.why.6.title': 'تنسجم مع أوقات المدرسة',
  'kids.why.6.desc': 'ينشر المعلمون أوقاتهم الفعلية عبر المناطق الزمنية المختلفة. احجز بعد المدرسة، أو في العطلة، أو قبيل الفجر في رمضان.',

  'kids.paths.eyebrow': 'مسار التعلّم',
  'kids.paths.title': 'نقطة البداية تختلف باختلاف عمر طفلك',
  'kids.paths.subtitle': 'الدرس الأول هو ما يحدد فيه المعلم مستوى الطفل. وهذه هي نقاط الانطلاق المعتادة.',
  'kids.paths.early.age': 'من 4 إلى 6 سنوات',
  'kids.paths.early.title': 'أول الحروف والأصوات',
  'kids.paths.early.b1': 'القاعدة النورانية بدءًا من الحروف الهجائية',
  'kids.paths.early.b2': 'قصار السور بالاستماع والترديد',
  'kids.paths.early.b3': 'دروس أقصر تناسب انتباه الصغار',
  'kids.paths.middle.age': 'من 7 إلى 10 سنوات',
  'kids.paths.middle.title': 'قراءة بثقة',
  'kids.paths.middle.b1': 'إتمام القاعدة والقراءة من المصحف',
  'kids.paths.middle.b2': 'أحكام التجويد الأساسية وتطبيقها أثناء القراءة',
  'kids.paths.middle.b3': 'حفظ جزء عمّ سورةً سورة',
  'kids.paths.teen.age': 'من 11 إلى 15 سنة',
  'kids.paths.teen.title': 'الحفظ والفهم',
  'kids.paths.teen.b1': 'حفظ منظّم وفق خطة مراجعة',
  'kids.paths.teen.b2': 'التجويد كاملًا بأحكامه الدقيقة',
  'kids.paths.teen.b3': 'فهم ما يتلوه الطفل ويحفظه',

  'kids.courses.eyebrow': 'الدورات',
  'kids.courses.title': 'دورات منظّمة للمتعلمين الصغار',
  'kids.courses.viewAll': 'تصفّح جميع الدورات',
  'kids.courses.free': 'مجانًا',
  'kids.courses.lessons': 'درسًا',

  'kids.teachers.eyebrow': 'المعلمون',
  'kids.teachers.title': 'معلمون متخصصون في تعليم الأطفال',
  'kids.teachers.subtitle': 'كل معلم هنا يذكر تعليم القرآن للأطفال ضمن تخصصاته. افتح ملفه لتطّلع على خبرته ولغاته وأوقاته المتاحة.',
  'kids.teachers.viewAll': 'عرض جميع المعلمين',
  'kids.teachers.perHour': '/ساعة',
  'kids.teachers.ijazahVerified': 'إجازة موثّقة',
  'kids.teachers.trialFrom': 'الجلسة التجريبية من',
  'kids.teachers.trialFree': 'جلسة تجريبية مجانية',
  'kids.teachers.empty': 'لا يوجد معلمون لعرضهم الآن. تصفّح جميع المعلمين بدلًا من ذلك.',
  'kids.teachers.error': 'تعذّر تحميل المعلمين الآن. يرجى المحاولة بعد قليل.',

  'kids.how.eyebrow': 'كيف تبدأ',
  'kids.how.title': 'أربع خطوات حتى الدرس الأول',
  'kids.how.1.title': 'أنشئ حساب ولي أمر',
  'kids.how.1.desc': 'لا يستغرق سوى دقيقة. أنت صاحب الحساب، وكل شيء يمرّ من خلالك.',
  'kids.how.2.title': 'أضف طفلك',
  'kids.how.2.desc': 'اسمه وعمره ومستواه. لا يحتاج إلى بريد إلكتروني ولا كلمة مرور.',
  'kids.how.3.title': 'اختر المعلم',
  'kids.how.3.desc': 'قارن بين المعلمين المتخصصين في تعليم الأطفال حسب التخصص واللغة والخبرة والسعر.',
  'kids.how.4.title': 'احجز الدرس الأول',
  'kids.how.4.desc': 'اختر موعدًا من تقويم المعلم المتاح. يجري الدرس داخل المتصفح — دون تثبيت أي برنامج.',

  'kids.safety.eyebrow': 'حماية الأطفال',
  'kids.safety.title': 'ما نلتزم به لأنهم أطفال',
  'kids.safety.1.title': 'توثيق المعلمين قبل التدريس',
  'kids.safety.1.desc': 'يقدّم كل معلم إجازته ووثائق هويته للمراجعة قبل اعتماد ملفه. وتبقى هذه الوثائق خاصة بفريق المراجعة وحده.',
  'kids.safety.2.title': 'الحساب حسابك أنت، لا حسابه',
  'kids.safety.2.desc': 'لا يملك الأطفال حسابات خاصة بهم. الحجز والدفع والموافقة تتم كلها من حساب ولي الأمر.',
  'kids.safety.3.title': 'جلسات فردية خاصة',
  'kids.safety.3.desc': 'الدروس جلسات مرئية فردية، ورابط الجلسة يُصدر لكل درس على حدة ولمن يحضره فقط.',
  'kids.safety.4.title': 'أنت تختار، ويمكنك التغيير',
  'kids.safety.4.desc': 'أنت من يختار معلم طفلك، ويمكنك نقله إلى معلم آخر متى شئت.',

  'kids.faq.eyebrow': 'لأولياء الأمور',
  'kids.faq.title': 'أسئلة يبدأ بها أولياء الأمور',
  'kids.faq.q1': 'في أي سن يمكن أن يبدأ طفلي؟',
  'kids.faq.a1': 'تبدأ كثير من الأسر في سن الرابعة أو الخامسة بالقاعدة النورانية — الحروف وأصواتها. ولا حدّ أدنى ثابتًا: يستعمل المعلم الدرس الأول ليعرف ما يتقنه طفلك بالفعل ثم ينطلق من هناك.',
  'kids.faq.q2': 'هل يحتاج طفلي إلى حساب خاص به؟',
  'kids.faq.a2': 'لا. تسجّل أنت كولي أمر وتضيف طفلك ملفًا داخل حسابك. لا حساب له ولا كلمة مرور ولا بريد — أنت من يحجز دروسه ويتابع تقدّمه من لوحة الأسرة.',
  'kids.faq.q3': 'هل يمكنني طلب معلمة؟',
  'kids.faq.a3': 'نعم. أكثر المتخصصين في تعليم القرآن للأطفال على هُدًى من المعلمات، وأنت من يختار المعلم عند الحجز — لا يُسنَد أحد إلى طفلك.',
  'kids.faq.q4': 'كم مدة الدرس وكم مرة في الأسبوع؟',
  'kids.faq.a4': 'الدروس فردية وتُحجز جلسةً جلسة، فأنت من يضبط الإيقاع. ويذكر كل معلم مدة الجلسة التي يدرّس بها في ملفه. تبدأ كثير من الأسر بدرسين أو ثلاثة أسبوعيًّا ثم تعدّل بعد أن ترى كيف يتأقلم طفلها.',
  'kids.faq.q5': 'ماذا سيتعلّم طفلي فعليًّا؟',
  'kids.faq.a5': 'يعتمد ذلك على السن والمستوى. يدرس الصغار القاعدة النورانية وقصار السور؛ والمرحلة التالية هي القراءة المتقنة من المصحف مع أحكام التجويد الأساسية؛ أما الأكبر سنًّا فينتقلون إلى الحفظ المنظّم وفق خطة مراجعة.',
  'kids.faq.q6': 'هل تدرّسون بالإنجليزية كما بالعربية؟',
  'kids.faq.a6': 'نعم. يذكر كل معلم اللغات التي يدرّس بها، فيستطيع الطفل الذي ينشأ خارج البلاد العربية أن يتعلّم القرآن على يد معلم يشرح له بلغة يرتاح إليها.',
  'kids.faq.q7': 'كم التكلفة؟',
  'kids.faq.a7': 'يحدد كل معلم أجره بالساعة، وهو معروض في ملفه. ويقدّم أكثرهم جلسة تجريبية بسعر أقل — وبعضهم مجانًا — لتتبيّن مدى انسجام طفلك معه قبل أن تلتزم.',

  'kids.cta.title': 'ابدأ بدرس واحد',
  'kids.cta.subtitle': 'أنشئ حساب ولي الأمر، وأضف طفلك، واحجز جلسة تجريبية مع معلم متخصص في تعليم الأطفال.',
  'kids.cta.primary': 'أنشئ حساب ولي أمر',
  'kids.cta.secondary': 'تصفّح جميع المعلمين',

  // ===========================================
  // مدفوعات الطالب (/student/payments)
  // دفع حجز أكّده المعلم، ورفع إيصال التحويل.
  // ===========================================
  'pay.nav': 'المدفوعات',
  'pay.title': 'المدفوعات',
  'pay.subtitle': 'سدّد الحجوزات المؤكّدة وتابع ما دفعته.',

  'pay.pending.title': 'بانتظار الدفع',
  'pay.pending.empty': 'لا شيء للدفع الآن',
  'pay.pending.emptyHint': 'عندما يؤكّد المعلم حجزًا يظهر هنا مع مهلة السداد.',
  'pay.pending.with': 'مع',
  'pay.pending.deadline': 'السداد قبل',
  'pay.pending.expired': 'انتهت المهلة',
  'pay.pending.daysLeft': 'يوم متبقٍ',
  'pay.pending.hoursLeft': 'ساعة متبقية',
  'pay.pending.minutesLeft': 'دقيقة متبقية',
  'pay.pending.pay': 'ادفع الآن',
  'pay.pending.awaitingVerification': 'أُرسل الإيصال — بانتظار التحقق',

  'pay.dialog.title': 'ادفع قيمة جلستك',
  'pay.dialog.method': 'كيف تودّ الدفع؟',
  'pay.dialog.continue': 'متابعة',
  'pay.dialog.noMethods': 'لا تتوفر وسيلة دفع بعد',
  'pay.dialog.noMethodsHint': 'لم تُفعّل المدفوعات على المنصة بعد. يرجى التواصل معنا لترتيب سداد هذا الحجز.',
  'pay.dialog.cardUnavailable': 'الدفع بالبطاقة غير متاح في التطبيق بعد — يرجى اختيار التحويل البنكي أو التواصل معنا.',
  'pay.dialog.loadError': 'تعذّر بدء عملية الدفع. يرجى المحاولة بعد قليل.',

  'pay.bank.title': 'حوّل المبلغ إلى هذا الحساب',
  'pay.bank.bankName': 'البنك',
  'pay.bank.accountName': 'صاحب الحساب',
  'pay.bank.accountNumber': 'رقم الحساب',
  'pay.bank.iban': 'الآيبان',
  'pay.bank.swift': 'سويفت / BIC',
  'pay.bank.instructions': 'تعليمات',
  'pay.bank.copy': 'نسخ',
  'pay.bank.copied': 'تم النسخ',
  'pay.bank.missing': 'لم تُدخل بيانات الحساب البنكي بعد — يرجى التواصل معنا قبل التحويل.',

  'pay.proof.title': 'ثم أرسل لنا الإيصال',
  'pay.proof.hint': 'ارفع إيصال التحويل وأضف الرقم المرجعي الذي منحك إياه البنك. يتحقق المشرف منه ثم تُعتمد الجلسة مدفوعة.',
  'pay.proof.reference': 'الرقم المرجعي للتحويل (اختياري)',
  'pay.proof.referencePlaceholder': 'مثال: TRX-4471902',
  'pay.proof.file': 'الإيصال',
  'pay.proof.choose': 'اختر ملفًا',
  'pay.proof.submit': 'إرسال الإيصال',
  'pay.proof.submitting': 'جارٍ الإرسال…',
  'pay.proof.needFile': 'يرجى إرفاق إيصال التحويل أولًا.',
  'pay.proof.tooLarge': 'حجم الملف يتجاوز 5 ميغابايت. يرجى إرفاق ملف أصغر.',
  'pay.proof.badType': 'يرجى إرفاق صورة أو ملف PDF.',
  'pay.proof.done': 'تم استلام الإيصال',
  'pay.proof.doneHint': 'سنتحقق من التحويل ونؤكّد جلستك، وسنخطرك فور اكتمال ذلك.',
  'pay.proof.close': 'إغلاق',

  'pay.free.done': 'لا مبلغ مستحق — هذه الجلسة مسدّدة بالفعل.',

  'pay.history.title': 'سجلّ المدفوعات',
  'pay.history.empty': 'لا توجد مدفوعات بعد',
  'pay.history.date': 'التاريخ',
  'pay.history.amount': 'المبلغ',
  'pay.history.method': 'الوسيلة',
  'pay.history.status': 'الحالة',

  'pay.status.Pending': 'قيد الانتظار',
  'pay.status.Processing': 'قيد المعالجة',
  'pay.status.Completed': 'مدفوع',
  'pay.status.Failed': 'فشل',
  'pay.status.Refunded': 'مُستردّ',
  'pay.status.Cancelled': 'ملغى',

  'pay.admin.verify': 'اعتماد',
  'pay.admin.reject': 'رفض',
  'pay.admin.actions': 'إجراءات',
  'pay.admin.proof': 'الإيصال',
  'pay.admin.viewProof': 'عرض الإيصال',
  'pay.admin.noProof': 'لم يُرفع إيصال',
  'pay.admin.reference': 'الرقم المرجعي',
  'pay.admin.verifyTitle': 'اعتماد هذه الدفعة؟',
  'pay.admin.verifyBody': 'سيُسجَّل استلام المبلغ وتُعتمد الجلسة مدفوعة. تحقّق من الإيصال في كشف حسابك أولًا.',
  'pay.admin.verifyConfirm': 'نعم، سجّل الاستلام',
  'pay.admin.rejectTitle': 'رفض هذه الدفعة',
  'pay.admin.rejectBody': 'سيُبلَّغ الطالب بالسبب، ويبقى الحجز غير مدفوع.',
  'pay.admin.rejectReason': 'السبب',
  'pay.admin.rejectPlaceholder': 'مثال: لا يوجد تحويل مطابق لهذا الرقم المرجعي',
  'pay.admin.rejectConfirm': 'رفض الدفعة',
  'pay.admin.verified': 'تم اعتماد الدفعة',
  'pay.admin.rejected': 'تم رفض الدفعة',
  'pay.admin.needReason': 'يرجى ذكر السبب.',
  'pay.admin.cancel': 'إلغاء',

  // ===========================================
  // صندوق طلبات الحجز للمعلم (/teacher/bookings)
  // حيث يُقبل طلب الطالب أو يُعتذر عنه.
  // ===========================================
  'tbk.nav': 'طلبات الحجز',
  'tbk.title': 'طلبات الحجز',
  'tbk.subtitle': 'عند تأكيدك للطلب يُطلب من الطالب السداد. ولا يُحجز أي موعد قبل ذلك.',

  'tbk.tab.pending': 'بانتظار ردّك',
  'tbk.tab.awaiting': 'بانتظار السداد',
  'tbk.tab.all': 'كل الطلبات',

  'tbk.empty.pending': 'لا توجد طلبات بانتظارك',
  'tbk.empty.pendingHint': 'تظهر هنا طلبات الحجز الجديدة من الطلاب.',
  'tbk.empty.awaiting': 'لا شيء بانتظار السداد',
  'tbk.empty.awaitingHint': 'تظهر هنا الطلبات التي أكّدتها إلى أن يسدّد الطالب.',
  'tbk.empty.all': 'لا توجد طلبات بعد',

  'tbk.card.requested': 'الموعد المطلوب',
  'tbk.card.duration': 'المدة',
  'tbk.card.minutes': 'دقيقة',
  'tbk.card.type': 'النوع',
  'tbk.card.message': 'ملاحظة الطالب',
  'tbk.card.payBy': 'على الطالب السداد قبل',
  'tbk.card.expired': 'انتهت مهلة السداد',

  'tbk.action.confirm': 'تأكيد',
  'tbk.action.reject': 'اعتذار',

  'tbk.confirm.title': 'تأكيد هذا الحجز؟',
  'tbk.confirm.body': 'سيُحجز الموعد ويُطلب من الطالب السداد. تُنشأ الجلسة فورًا لكنها تبقى غير مدفوعة حتى يسدّد.',
  'tbk.confirm.response': 'رسالة إلى الطالب (اختياري)',
  'tbk.confirm.placeholder': 'مثال: بانتظارك بإذن الله — أحضر مصحفك معك.',
  'tbk.confirm.submit': 'تأكيد الحجز',

  'tbk.reject.title': 'الاعتذار عن هذا الحجز',
  'tbk.reject.body': 'سيُبلَّغ الطالب بالسبب، ويُفرَج عن الموعد.',
  'tbk.reject.reason': 'السبب',
  'tbk.reject.placeholder': 'مثال: لا أتفرّغ في هذا الوقت — هل يناسبك المساء؟',
  'tbk.reject.submit': 'إرسال الاعتذار',
  'tbk.reject.needReason': 'يرجى ذكر سبب للطالب.',

  'tbk.cancel': 'إلغاء',
  'tbk.toast.confirmed': 'تم تأكيد الحجز — وطُلب من الطالب السداد.',
  'tbk.toast.rejected': 'تم الاعتذار عن الحجز.',
  'tbk.toast.error': 'لم تتم العملية. يرجى المحاولة بعد قليل.',

  'tbk.status.Pending': 'بانتظار ردّك',
  'tbk.status.Confirmed': 'مؤكَّد',
  'tbk.status.Payment Pending': 'بانتظار السداد',
  'tbk.status.Paid': 'مدفوع',
  'tbk.status.Completed': 'مكتمل',
  'tbk.status.Cancelled': 'ملغى',
  'tbk.status.Rejected': 'معتذَر عنه',
  'tbk.status.Expired': 'منتهٍ',

  // ===========================================
  // لوحة التحكم ← المدفوعات (متصلة بإعدادات هُدًى)
  // ===========================================
  'admin.pay.bankName': 'اسم البنك',
  'admin.pay.accountName': 'اسم صاحب الحساب',
  'admin.pay.accountNumber': 'رقم الحساب',
  'admin.pay.iban': 'الآيبان (IBAN)',
  'admin.pay.swift': 'رمز سويفت / BIC',
  'admin.pay.instructionsEn': 'تعليمات الدفع (بالإنجليزية)',
  'admin.pay.instructionsAr': 'تعليمات الدفع (بالعربية)',
  'admin.pay.studentsSeeHint': 'يرى الطلاب الذين يختارون التحويل المصرفي هذه البيانات في صفحة الدفع، فأدخلها كما تظهر في الحساب تمامًا.',
  'admin.pay.secretStored': 'محفوظ — اتركه فارغًا للإبقاء على القيمة الحالية',
  'admin.pay.saved': 'تم حفظ إعدادات الدفع',
  'admin.pay.saveFailed': 'تعذر حفظ إعدادات الدفع',
  'admin.pay.noChanges': 'لا توجد تغييرات للحفظ',
  'admin.pay.needBankDetails': 'أدخل بيانات الحساب البنكي قبل تفعيل الدفع اليدوي — وإلا سيرى الطلاب صفحة دفع فارغة.',
  'admin.pay.loadFailed': 'تعذر تحميل إعدادات الدفع',
  'tapDescription': 'قبول مدفوعات مدى وكي نت وبنفت في دول الخليج عبر Tap',
  'enableTap': 'تفعيل مدفوعات Tap',
  'enableTapDescription': 'سيتمكن الطلاب من الدفع ببطاقات الخصم والائتمان الخليجية',
  'tapPublishableKey': 'مفتاح Tap القابل للنشر',
  'tapSecretKey': 'مفتاح Tap السري',
  'tapWebhookSecret': 'سر ويب هوك Tap',

  // Phase 1 backlog (2026-09-05): refunds, verification nag, payment window
  'pay.history.refund': 'الاسترداد',
  'pay.refund.request': 'طلب استرداد',
  'pay.refund.title': 'طلب استرداد المبلغ',
  'pay.refund.hint': 'أخبرنا بما حدث. يراجع المشرف كل طلب؛ والمبلغ المستحق هو',
  'pay.refund.reason': 'السبب',
  'pay.refund.reasonPlaceholder': 'مثال: لم ينضم المعلم إلى الجلسة',
  'pay.refund.submit': 'إرسال الطلب',
  'pay.refund.sent': 'تم إرسال طلب الاسترداد',
  'pay.refund.failed': 'تعذر إرسال طلب الاسترداد',
  'pay.refund.status.Pending': 'طلب الاسترداد قيد المراجعة',
  'pay.refund.status.Approved': 'تمت الموافقة على الاسترداد',
  'pay.refund.status.Processing': 'جارٍ تنفيذ الاسترداد',
  'pay.refund.status.Completed': 'مُستردّ',
  'pay.refund.status.Rejected': 'رُفض طلب الاسترداد',
  'pay.refund.why.dispute_window_closed': 'انتهت مهلة الاسترداد (7 أيام)',
  'pay.refund.why.policy_zero': 'لا استرداد: أُلغيت قبل أقل من 12 ساعة',
  'pay.refund.why.refund_rejected': 'تمت مراجعة طلب الاسترداد سابقًا',
  'pay.refund.why.cancel_instead': 'ألغِ الجلسة للحصول على استرداد',
  'verify.nag.title': 'يرجى تأكيد بريدك الإلكتروني',
  'verify.nag.body': 'أرسلنا رابط التأكيد إلى',
  'sending': 'جارٍ الإرسال...',
  'verify.nag.resend': 'إعادة إرسال البريد',
  'verify.nag.sentShort': 'تم الإرسال',
  'verify.nag.sent': 'تم إرسال بريد التأكيد. يرجى مراجعة صندوق الوارد.',
  'verify.nag.failed': 'تعذر إرسال بريد التأكيد. حاول مرة أخرى بعد قليل.',
  'verify.nag.dismiss': 'إخفاء الآن',
  'admin.pay.window.title': 'مهلة الدفع',
  'admin.pay.window.description': 'المدة المتاحة للطالب للدفع بعد تأكيد المعلم للحجز. عند انتهائها يُحرَّر الموعد ويُبلَّغ الطالب.',
  'admin.pay.window.label': 'عدد ساعات الدفع بعد التأكيد',
  'admin.pay.window.hint': 'اتركه فارغًا للقيمة الافتراضية (24 ساعة). من 1 إلى 168 ساعة.',
  'admin.pay.window.invalid': 'يجب أن تكون مهلة الدفع عددًا صحيحًا بين 1 و168 ساعة',
  // Parent payment path (2026-09-05)
  'family.payments.nav': 'المدفوعات',
  'family.payments.heading': 'مدفوعات العائلة',
  'family.payments.subheading': 'ادفع رسوم جلسات أطفالك المؤكدة وتابع ما دفعته.',
  'pay.pending.for': 'لصالح',
  'pay.history.for': 'لصالح',
  // Session join (2026-09-05)
  'session.join.button': 'انضم',
  'session.join.openExternal': 'افتح رابط الاجتماع',
  'session.join.externalHint': 'أعدّ معلمك هذه الجلسة على خدمة اجتماعات خارجية، وستُفتح في تبويب جديد.',
  'session.join.connecting': 'جارٍ توصيلك بالغرفة...',
  'session.join.retry': 'حاول مرة أخرى',
  'session.join.not_found': 'الجلسة غير موجودة',
  'session.join.forbidden': 'لست مشاركًا في هذه الجلسة',
  'session.join.closed': 'انتهت هذه الجلسة بالفعل',
  'session.join.no_room': 'غرفة الاجتماع ليست جاهزة بعد. تُنشأ بعد دفع الجلسة.',
  'session.join.too_early': 'يمكنك الانضمام قبل بدء الجلسة بـ 15 دقيقة',
  'session.join.ended': 'انتهى وقت هذه الجلسة',
  'session.join.token_failed': 'تعذر فتح غرفة الفيديو. حاول مرة أخرى بعد قليل.',
  'session.join.error': 'تعذر فتح الجلسة. حاول مرة أخرى.',
  // Wallet checkout (2026-09-05)
  'pay.method.wallet': 'رصيد المحفظة',
  'pay.method.walletBalance': 'المتاح:',
  'pay.method.walletInsufficient': 'الرصيد بهذه العملة غير كافٍ. المتاح:',
  'pay.wallet.paid': 'تم الدفع من رصيد محفظتك',
  'admin.finance.otherCurrencies': 'وردت أيضًا بعملات أخرى (غير مشمولة أعلاه):',
  // Password settings (2026-09-05)
  'settings.password.title': 'تغيير كلمة المرور',
  'settings.password.description': 'اختر كلمة مرور جديدة لحسابك.',
  'settings.password.current': 'كلمة المرور الحالية',
  'settings.password.new': 'كلمة المرور الجديدة',
  'settings.password.confirm': 'تأكيد كلمة المرور الجديدة',
  'settings.password.minLength': '8 أحرف على الأقل.',
  'settings.password.mismatch': 'كلمتا المرور غير متطابقتين.',
  'settings.password.submit': 'تحديث كلمة المرور',
  'settings.password.updated': 'تم تحديث كلمة المرور',
  'settings.password.failed': 'تعذر تغيير كلمة المرور. تحقق من كلمة المرور الحالية وحاول مرة أخرى.',
  // Teacher homework + admin courses (2026-09-05)
  'thw.nav': 'الواجبات',
  'thw.title': 'الواجبات',
  'thw.subtitle': 'كلّف طلابك بالحفظ والمراجعة والتدريب، ثم قيّم ما يرسلونه.',
  'thw.assign': 'تكليف بواجب',
  'thw.assignHint': 'يراه الطالب في صفحة الواجبات ويرسله من هناك.',
  'thw.list': 'التكليفات',
  'thw.empty': 'لا توجد واجبات بعد',
  'thw.emptyHint': 'أضف أول تكليف من الزر أعلاه.',
  'thw.review': 'تقييم',
  'thw.submitReview': 'حفظ التقييم',
  'thw.student': 'الطالب',
  'thw.pickStudent': 'اختر طالبًا',
  'thw.typeLabel': 'النوع',
  'thw.surah': 'السورة',
  'thw.ayah': 'آية',
  'thw.fromAyah': 'من آية',
  'thw.toAyah': 'إلى آية',
  'thw.due': 'الموعد',
  'thw.instructions': 'تعليمات (اختياري)',
  'thw.selfAssessment': 'التقييم الذاتي',
  'thw.timeSpent': 'الوقت المستغرق',
  'thw.minutes': 'دقيقة',
  'thw.rating': 'التقييم',
  'thw.pickRating': 'اختر تقييمًا',
  'thw.feedback': 'ملاحظات للطالب (اختياري)',
  'thw.toast.assigned': 'تم تكليف الطالب بالواجب',
  'thw.toast.assignFailed': 'تعذر تكليف الواجب',
  'thw.toast.reviewed': 'تم حفظ التقييم',
  'thw.toast.reviewFailed': 'تعذر حفظ التقييم',
  'thw.status.all': 'الكل',
  'thw.status.Assigned': 'مُكلَّف',
  'thw.status.In Progress': 'قيد الإنجاز',
  'thw.status.Submitted': 'مُرسَل',
  'thw.status.Reviewed': 'مُقيَّم',
  'thw.status.Overdue': 'متأخر',
  'thw.type.Memorization': 'حفظ',
  'thw.type.Revision': 'مراجعة',
  'thw.type.Tajweed Practice': 'تدريب تجويد',
  'thw.type.Recitation': 'تلاوة',
  'thw.type.Listening': 'استماع',
  'thw.rating.Excellent': 'ممتاز',
  'thw.rating.Good': 'جيد',
  'thw.rating.Needs Practice': 'يحتاج تدريبًا',
  'thw.rating.Not Ready': 'غير جاهز',
  'admin.courses.title': 'الدورات',
  'admin.courses.directory': 'دليل الدورات',
  'admin.courses.description': 'كل الدورات على المنصة. ينشئ المعلمون دوراتهم ويعدّلونها من بوابة المعلم.',
  'admin.courses.search': 'ابحث بالعنوان أو المعلم',
  'admin.courses.loadFailed': 'تعذر تحميل الدورات',
  'admin.courses.empty': 'لا توجد دورات مطابقة',
  'admin.courses.featured': 'مميزة',
  'admin.courses.free': 'مجانية',
  'admin.courses.view': 'عرض',
  'admin.courses.col.title': 'العنوان',
  'admin.courses.col.teacher': 'المعلم',
  'admin.courses.col.level': 'المستوى',
  'admin.courses.col.price': 'السعر',
  'admin.courses.col.students': 'الطلاب',
  'admin.courses.col.status': 'الحالة',
  'admin.courses.col.actions': 'إجراءات',
  'admin.courses.status.all': 'كل الحالات',
  'admin.courses.status.Published': 'منشورة',
  'admin.courses.status.Pending Review': 'بانتظار المراجعة',
  'admin.courses.status.Draft': 'مسودة',
  'admin.courses.status.Archived': 'مؤرشفة',
};
